{
    "name": "Bambulab",
    "url": "http://www.bambulab.com/Parameters/vendor/BBL.json",
    "version": "02.01.00.13",
    "force_update": "0",
    "description": "the initial version of BBL configurations",
    "machine_model_list": [
        {
            "name": "Bambu Lab X1 Carbon",
            "sub_path": "machine/Bambu Lab X1 Carbon.json"
        },
        {
            "name": "Bambu Lab X1",
            "sub_path": "machine/Bambu Lab X1.json"
        },
        {
            "name": "Bambu Lab X1E",
            "sub_path": "machine/Bambu Lab X1E.json"
        },
        {
            "name": "Bambu Lab P1P",
            "sub_path": "machine/Bambu Lab P1P.json"
        },
        {
            "name": "Bambu Lab P1S",
            "sub_path": "machine/Bambu Lab P1S.json"
        },
        {
            "name": "Bambu Lab A1 mini",
            "sub_path": "machine/Bambu Lab A1 mini.json"
        },
        {
            "name": "Bambu Lab A1",
            "sub_path": "machine/Bambu Lab A1.json"
        },
        {
            "name": "Bambu Lab H2D",
            "sub_path": "machine/Bambu Lab H2D.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "fdm_process_dual_common",
            "sub_path": "process/fdm_process_dual_common.json"
        },
        {
            "name": "fdm_process_dual_0.06_nozzle_0.2",
            "sub_path": "process/fdm_process_dual_0.06_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_dual_0.08_nozzle_0.2",
            "sub_path": "process/fdm_process_dual_0.08_nozzle_0.2.json"
        },
        {
            "name": "0.08mm Extra Fine @BBL H2D 0.2 nozzle",
            "sub_path": "process/0.08mm Extra Fine @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.08_nozzle_0.4",
            "sub_path": "process/fdm_process_dual_0.08_nozzle_0.4.json"
        },
        {
            "name": "0.08mm Extra Fine @BBL H2D",
            "sub_path": "process/0.08mm Extra Fine @BBL H2D.json"
        },
        {
            "name": "fdm_process_dual_0.10_nozzle_0.2",
            "sub_path": "process/fdm_process_dual_0.10_nozzle_0.2.json"
        },
        {
            "name": "0.10mm Standard @BBL H2D 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.12_nozzle_0.2",
            "sub_path": "process/fdm_process_dual_0.12_nozzle_0.2.json"
        },
        {
            "name": "0.12mm Balanced Quality @BBL H2D 0.2 nozzle",
            "sub_path": "process/0.12mm Balanced Quality @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.12_nozzle_0.4",
            "sub_path": "process/fdm_process_dual_0.12_nozzle_0.4.json"
        },
        {
            "name": "0.12mm Fine @BBL H2D",
            "sub_path": "process/0.12mm Fine @BBL H2D.json"
        },
        {
            "name": "fdm_process_dual_0.14_nozzle_0.2",
            "sub_path": "process/fdm_process_dual_0.14_nozzle_0.2.json"
        },
        {
            "name": "fdm_process_dual_0.16_nozzle_0.4",
            "sub_path": "process/fdm_process_dual_0.16_nozzle_0.4.json"
        },
        {
            "name": "0.16mm Balanced Quality @BBL H2D",
            "sub_path": "process/0.16mm Balanced Quality @BBL H2D.json"
        },
        {
            "name": "0.16mm Standard @BBL H2D",
            "sub_path": "process/0.16mm Standard @BBL H2D.json"
        },
        {
            "name": "fdm_process_dual_0.18_nozzle_0.6",
            "sub_path": "process/fdm_process_dual_0.18_nozzle_0.6.json"
        },
        {
            "name": "0.18mm Balanced Quality @BBL H2D 0.6 nozzle",
            "sub_path": "process/0.18mm Balanced Quality @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.20_nozzle_0.4",
            "sub_path": "process/fdm_process_dual_0.20_nozzle_0.4.json"
        },
        {
            "name": "0.20mm Balanced Strength @BBL H2D",
            "sub_path": "process/0.20mm Balanced Strength @BBL H2D.json"
        },
        {
            "name": "0.20mm Standard @BBL H2D",
            "sub_path": "process/0.20mm Standard @BBL H2D.json"
        },
        {
            "name": "fdm_process_dual_0.24_nozzle_0.4",
            "sub_path": "process/fdm_process_dual_0.24_nozzle_0.4.json"
        },
        {
            "name": "0.24mm Standard @BBL H2D",
            "sub_path": "process/0.24mm Standard @BBL H2D.json"
        },
        {
            "name": "fdm_process_dual_0.24_nozzle_0.6",
            "sub_path": "process/fdm_process_dual_0.24_nozzle_0.6.json"
        },
        {
            "name": "0.24mm Balanced Strength @BBL H2D 0.6 nozzle",
            "sub_path": "process/0.24mm Balanced Strength @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.24_nozzle_0.8",
            "sub_path": "process/fdm_process_dual_0.24_nozzle_0.8.json"
        },
        {
            "name": "0.24mm Balanced Quality @BBL H2D 0.8 nozzle",
            "sub_path": "process/0.24mm Balanced Quality @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.28_nozzle_0.4",
            "sub_path": "process/fdm_process_dual_0.28_nozzle_0.4.json"
        },
        {
            "name": "fdm_process_dual_0.30_nozzle_0.6",
            "sub_path": "process/fdm_process_dual_0.30_nozzle_0.6.json"
        },
        {
            "name": "0.30mm Standard @BBL H2D 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.32_nozzle_0.8",
            "sub_path": "process/fdm_process_dual_0.32_nozzle_0.8.json"
        },
        {
            "name": "0.32mm Balanced Strength @BBL H2D 0.8 nozzle",
            "sub_path": "process/0.32mm Balanced Strength @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.36_nozzle_0.6",
            "sub_path": "process/fdm_process_dual_0.36_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_dual_0.40_nozzle_0.8",
            "sub_path": "process/fdm_process_dual_0.40_nozzle_0.8.json"
        },
        {
            "name": "0.40mm Standard @BBL H2D 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_dual_0.42_nozzle_0.6",
            "sub_path": "process/fdm_process_dual_0.42_nozzle_0.6.json"
        },
        {
            "name": "fdm_process_dual_0.48_nozzle_0.8",
            "sub_path": "process/fdm_process_dual_0.48_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_dual_0.56_nozzle_0.8",
            "sub_path": "process/fdm_process_dual_0.56_nozzle_0.8.json"
        },
        {
            "name": "fdm_process_single_common",
            "sub_path": "process/fdm_process_single_common.json"
        },
        {
            "name": "fdm_process_single_0.06_nozzle_0.2",
            "sub_path": "process/fdm_process_single_0.06_nozzle_0.2.json"
        },
        {
            "name": "0.06mm Fine @BBL A1 0.2 nozzle",
            "sub_path": "process/0.06mm Fine @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.06mm Fine @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.06mm Fine @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.06mm Fine @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.06mm Fine @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.06mm High Quality @BBL A1 0.2 nozzle",
            "sub_path": "process/0.06mm High Quality @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.06mm High Quality @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.06mm High Quality @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.06mm High Quality @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.06mm High Quality @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.06mm High Quality @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.06mm High Quality @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "0.06mm Standard @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.06mm Standard @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.08",
            "sub_path": "process/fdm_process_single_0.08.json"
        },
        {
            "name": "0.08mm Extra Fine @BBL A1",
            "sub_path": "process/0.08mm Extra Fine @BBL A1.json"
        },
        {
            "name": "0.08mm Extra Fine @BBL A1M",
            "sub_path": "process/0.08mm Extra Fine @BBL A1M.json"
        },
        {
            "name": "0.08mm Extra Fine @BBL P1P",
            "sub_path": "process/0.08mm Extra Fine @BBL P1P.json"
        },
        {
            "name": "0.08mm Extra Fine @BBL X1C",
            "sub_path": "process/0.08mm Extra Fine @BBL X1C.json"
        },
        {
            "name": "0.08mm High Quality @BBL A1",
            "sub_path": "process/0.08mm High Quality @BBL A1.json"
        },
        {
            "name": "0.08mm High Quality @BBL A1M",
            "sub_path": "process/0.08mm High Quality @BBL A1M.json"
        },
        {
            "name": "0.08mm High Quality @BBL P1P",
            "sub_path": "process/0.08mm High Quality @BBL P1P.json"
        },
        {
            "name": "0.08mm High Quality @BBL X1C",
            "sub_path": "process/0.08mm High Quality @BBL X1C.json"
        },
        {
            "name": "fdm_process_single_0.08_nozzle_0.2",
            "sub_path": "process/fdm_process_single_0.08_nozzle_0.2.json"
        },
        {
            "name": "0.08mm High Quality @BBL A1 0.2 nozzle",
            "sub_path": "process/0.08mm High Quality @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.08mm High Quality @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.08mm High Quality @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.08mm High Quality @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.08mm High Quality @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.08mm High Quality @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.08mm High Quality @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "0.08mm Optimal @BBL A1 0.2 nozzle",
            "sub_path": "process/0.08mm Optimal @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.08mm Optimal @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.08mm Optimal @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.08mm Optimal @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.08mm Optimal @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.08mm Standard @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.08mm Standard @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.10_nozzle_0.2",
            "sub_path": "process/fdm_process_single_0.10_nozzle_0.2.json"
        },
        {
            "name": "0.10mm High Quality @BBL A1 0.2 nozzle",
            "sub_path": "process/0.10mm High Quality @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.10mm High Quality @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.10mm High Quality @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.10mm High Quality @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.10mm High Quality @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.10mm High Quality @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.10mm High Quality @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @BBL A1 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.10mm Standard @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.10mm Standard @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.12",
            "sub_path": "process/fdm_process_single_0.12.json"
        },
        {
            "name": "0.12mm Fine @BBL A1",
            "sub_path": "process/0.12mm Fine @BBL A1.json"
        },
        {
            "name": "0.12mm Fine @BBL A1M",
            "sub_path": "process/0.12mm Fine @BBL A1M.json"
        },
        {
            "name": "0.12mm Fine @BBL P1P",
            "sub_path": "process/0.12mm Fine @BBL P1P.json"
        },
        {
            "name": "0.12mm Fine @BBL X1C",
            "sub_path": "process/0.12mm Fine @BBL X1C.json"
        },
        {
            "name": "0.12mm High Quality @BBL A1",
            "sub_path": "process/0.12mm High Quality @BBL A1.json"
        },
        {
            "name": "0.12mm High Quality @BBL A1M",
            "sub_path": "process/0.12mm High Quality @BBL A1M.json"
        },
        {
            "name": "0.12mm High Quality @BBL P1P",
            "sub_path": "process/0.12mm High Quality @BBL P1P.json"
        },
        {
            "name": "0.12mm High Quality @BBL X1C",
            "sub_path": "process/0.12mm High Quality @BBL X1C.json"
        },
        {
            "name": "fdm_process_single_0.12_nozzle_0.2",
            "sub_path": "process/fdm_process_single_0.12_nozzle_0.2.json"
        },
        {
            "name": "0.12mm Draft @BBL A1 0.2 nozzle",
            "sub_path": "process/0.12mm Draft @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Draft @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.12mm Draft @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Draft @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.12mm Draft @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.12mm Standard @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.12mm Standard @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.14_nozzle_0.2",
            "sub_path": "process/fdm_process_single_0.14_nozzle_0.2.json"
        },
        {
            "name": "0.14mm Extra Draft @BBL A1 0.2 nozzle",
            "sub_path": "process/0.14mm Extra Draft @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "0.14mm Extra Draft @BBL A1M 0.2 nozzle",
            "sub_path": "process/0.14mm Extra Draft @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "0.14mm Extra Draft @BBL P1P 0.2 nozzle",
            "sub_path": "process/0.14mm Extra Draft @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "0.14mm Standard @BBL X1C 0.2 nozzle",
            "sub_path": "process/0.14mm Standard @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.16",
            "sub_path": "process/fdm_process_single_0.16.json"
        },
        {
            "name": "0.16mm High Quality @BBL A1",
            "sub_path": "process/0.16mm High Quality @BBL A1.json"
        },
        {
            "name": "0.16mm High Quality @BBL A1M",
            "sub_path": "process/0.16mm High Quality @BBL A1M.json"
        },
        {
            "name": "0.16mm High Quality @BBL P1P",
            "sub_path": "process/0.16mm High Quality @BBL P1P.json"
        },
        {
            "name": "0.16mm High Quality @BBL X1C",
            "sub_path": "process/0.16mm High Quality @BBL X1C.json"
        },
        {
            "name": "0.16mm Optimal @BBL A1",
            "sub_path": "process/0.16mm Optimal @BBL A1.json"
        },
        {
            "name": "0.16mm Optimal @BBL A1M",
            "sub_path": "process/0.16mm Optimal @BBL A1M.json"
        },
        {
            "name": "0.16mm Optimal @BBL P1P",
            "sub_path": "process/0.16mm Optimal @BBL P1P.json"
        },
        {
            "name": "0.16mm Optimal @BBL X1C",
            "sub_path": "process/0.16mm Optimal @BBL X1C.json"
        },
        {
            "name": "fdm_process_single_0.18_nozzle_0.6",
            "sub_path": "process/fdm_process_single_0.18_nozzle_0.6.json"
        },
        {
            "name": "0.18mm Fine @BBL A1 0.6 nozzle",
            "sub_path": "process/0.18mm Fine @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "0.18mm Fine @BBL A1M 0.6 nozzle",
            "sub_path": "process/0.18mm Fine @BBL A1M 0.6 nozzle.json"
        },
        {
            "name": "0.18mm Fine @BBL P1P 0.6 nozzle",
            "sub_path": "process/0.18mm Fine @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "0.18mm Standard @BBL X1C 0.6 nozzle",
            "sub_path": "process/0.18mm Standard @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.20",
            "sub_path": "process/fdm_process_single_0.20.json"
        },
        {
            "name": "0.20mm Standard @BBL A1",
            "sub_path": "process/0.20mm Standard @BBL A1.json"
        },
        {
            "name": "0.20mm Standard @BBL P1P",
            "sub_path": "process/0.20mm Standard @BBL P1P.json"
        },
        {
            "name": "0.20mm Standard @BBL A1M",
            "sub_path": "process/0.20mm Standard @BBL A1M.json"
        },
        {
            "name": "0.20mm Standard @BBL X1C",
            "sub_path": "process/0.20mm Standard @BBL X1C.json"
        },
        {
            "name": "0.20mm Strength @BBL A1",
            "sub_path": "process/0.20mm Strength @BBL A1.json"
        },
        {
            "name": "0.20mm Strength @BBL P1P",
            "sub_path": "process/0.20mm Strength @BBL P1P.json"
        },
        {
            "name": "0.20mm Strength @BBL A1M",
            "sub_path": "process/0.20mm Strength @BBL A1M.json"
        },
        {
            "name": "0.20mm Strength @BBL X1C",
            "sub_path": "process/0.20mm Strength @BBL X1C.json"
        },
        {
            "name": "fdm_process_single_0.24",
            "sub_path": "process/fdm_process_single_0.24.json"
        },
        {
            "name": "0.24mm Draft @BBL A1",
            "sub_path": "process/0.24mm Draft @BBL A1.json"
        },
        {
            "name": "0.24mm Draft @BBL A1M",
            "sub_path": "process/0.24mm Draft @BBL A1M.json"
        },
        {
            "name": "0.24mm Draft @BBL P1P",
            "sub_path": "process/0.24mm Draft @BBL P1P.json"
        },
        {
            "name": "0.24mm Draft @BBL X1C",
            "sub_path": "process/0.24mm Draft @BBL X1C.json"
        },
        {
            "name": "fdm_process_single_0.24_nozzle_0.6",
            "sub_path": "process/fdm_process_single_0.24_nozzle_0.6.json"
        },
        {
            "name": "0.24mm Optimal @BBL A1 0.6 nozzle",
            "sub_path": "process/0.24mm Optimal @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "0.24mm Optimal @BBL A1M 0.6 nozzle",
            "sub_path": "process/0.24mm Optimal @BBL A1M 0.6 nozzle.json"
        },
        {
            "name": "0.24mm Optimal @BBL P1P 0.6 nozzle",
            "sub_path": "process/0.24mm Optimal @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "0.24mm Standard @BBL X1C 0.6 nozzle",
            "sub_path": "process/0.24mm Standard @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.24_nozzle_0.8",
            "sub_path": "process/fdm_process_single_0.24_nozzle_0.8.json"
        },
        {
            "name": "0.24mm Fine @BBL A1 0.8 nozzle",
            "sub_path": "process/0.24mm Fine @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "0.24mm Fine @BBL A1M 0.8 nozzle",
            "sub_path": "process/0.24mm Fine @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "0.24mm Fine @BBL P1P 0.8 nozzle",
            "sub_path": "process/0.24mm Fine @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "0.24mm Standard @BBL X1C 0.8 nozzle",
            "sub_path": "process/0.24mm Standard @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.28",
            "sub_path": "process/fdm_process_single_0.28.json"
        },
        {
            "name": "0.28mm Extra Draft @BBL A1",
            "sub_path": "process/0.28mm Extra Draft @BBL A1.json"
        },
        {
            "name": "0.28mm Extra Draft @BBL A1M",
            "sub_path": "process/0.28mm Extra Draft @BBL A1M.json"
        },
        {
            "name": "0.28mm Extra Draft @BBL P1P",
            "sub_path": "process/0.28mm Extra Draft @BBL P1P.json"
        },
        {
            "name": "0.28mm Extra Draft @BBL X1C",
            "sub_path": "process/0.28mm Extra Draft @BBL X1C.json"
        },
        {
            "name": "fdm_process_single_0.30_nozzle_0.6",
            "sub_path": "process/fdm_process_single_0.30_nozzle_0.6.json"
        },
        {
            "name": "0.30mm Standard @BBL A1 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @BBL P1P 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @BBL A1M 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @BBL A1M 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @BBL X1 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @BBL X1 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Standard @BBL X1C 0.6 nozzle",
            "sub_path": "process/0.30mm Standard @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Strength @BBL A1 0.6 nozzle",
            "sub_path": "process/0.30mm Strength @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Strength @BBL A1M 0.6 nozzle",
            "sub_path": "process/0.30mm Strength @BBL A1M 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Strength @BBL P1P 0.6 nozzle",
            "sub_path": "process/0.30mm Strength @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "0.30mm Strength @BBL X1C 0.6 nozzle",
            "sub_path": "process/0.30mm Strength @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.32_nozzle_0.8",
            "sub_path": "process/fdm_process_single_0.32_nozzle_0.8.json"
        },
        {
            "name": "0.32mm Optimal @BBL A1 0.8 nozzle",
            "sub_path": "process/0.32mm Optimal @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "0.32mm Optimal @BBL A1M 0.8 nozzle",
            "sub_path": "process/0.32mm Optimal @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "0.32mm Optimal @BBL P1P 0.8 nozzle",
            "sub_path": "process/0.32mm Optimal @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "0.32mm Standard @BBL X1C 0.8 nozzle",
            "sub_path": "process/0.32mm Standard @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.36_nozzle_0.6",
            "sub_path": "process/fdm_process_single_0.36_nozzle_0.6.json"
        },
        {
            "name": "0.36mm Draft @BBL A1 0.6 nozzle",
            "sub_path": "process/0.36mm Draft @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Draft @BBL A1M 0.6 nozzle",
            "sub_path": "process/0.36mm Draft @BBL A1M 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Draft @BBL P1P 0.6 nozzle",
            "sub_path": "process/0.36mm Draft @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "0.36mm Standard @BBL X1C 0.6 nozzle",
            "sub_path": "process/0.36mm Standard @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.40_nozzle_0.8",
            "sub_path": "process/fdm_process_single_0.40_nozzle_0.8.json"
        },
        {
            "name": "0.40mm Standard @BBL A1 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @BBL P1P 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @BBL A1M 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @BBL X1 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @BBL X1 0.8 nozzle.json"
        },
        {
            "name": "0.40mm Standard @BBL X1C 0.8 nozzle",
            "sub_path": "process/0.40mm Standard @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.42_nozzle_0.6",
            "sub_path": "process/fdm_process_single_0.42_nozzle_0.6.json"
        },
        {
            "name": "0.42mm Extra Draft @BBL A1 0.6 nozzle",
            "sub_path": "process/0.42mm Extra Draft @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "0.42mm Extra Draft @BBL A1M 0.6 nozzle",
            "sub_path": "process/0.42mm Extra Draft @BBL A1M 0.6 nozzle.json"
        },
        {
            "name": "0.42mm Extra Draft @BBL P1P 0.6 nozzle",
            "sub_path": "process/0.42mm Extra Draft @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "0.42mm Standard @BBL X1C 0.6 nozzle",
            "sub_path": "process/0.42mm Standard @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.48_nozzle_0.8",
            "sub_path": "process/fdm_process_single_0.48_nozzle_0.8.json"
        },
        {
            "name": "0.48mm Draft @BBL A1 0.8 nozzle",
            "sub_path": "process/0.48mm Draft @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "0.48mm Draft @BBL A1M 0.8 nozzle",
            "sub_path": "process/0.48mm Draft @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "0.48mm Draft @BBL P1P 0.8 nozzle",
            "sub_path": "process/0.48mm Draft @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "0.48mm Standard @BBL X1C 0.8 nozzle",
            "sub_path": "process/0.48mm Standard @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "fdm_process_single_0.56_nozzle_0.8",
            "sub_path": "process/fdm_process_single_0.56_nozzle_0.8.json"
        },
        {
            "name": "0.56mm Extra Draft @BBL A1 0.8 nozzle",
            "sub_path": "process/0.56mm Extra Draft @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "0.56mm Extra Draft @BBL A1M 0.8 nozzle",
            "sub_path": "process/0.56mm Extra Draft @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "0.56mm Extra Draft @BBL P1P 0.8 nozzle",
            "sub_path": "process/0.56mm Extra Draft @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "0.56mm Standard @BBL X1C 0.8 nozzle",
            "sub_path": "process/0.56mm Standard @BBL X1C 0.8 nozzle.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "Bambu ABS @base",
            "sub_path": "filament/Bambu ABS @base.json"
        },
        {
            "name": "Bambu ABS @BBL A1",
            "sub_path": "filament/Bambu ABS @BBL A1.json"
        },
        {
            "name": "Bambu ABS @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu ABS @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL H2D",
            "sub_path": "filament/Bambu ABS @BBL H2D.json"
        },
        {
            "name": "Bambu ABS @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu ABS @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu ABS @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL P1P",
            "sub_path": "filament/P1P/Bambu ABS @BBL P1P.json"
        },
        {
            "name": "Bambu ABS @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu ABS @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL X1C",
            "sub_path": "filament/Bambu ABS @BBL X1C.json"
        },
        {
            "name": "Bambu ABS @BBL X1E",
            "sub_path": "filament/Bambu ABS @BBL X1E.json"
        },
        {
            "name": "Bambu ABS @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu ABS @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Bambu ABS @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu ABS @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu ABS @BBL X1E 0.8 nozzle",
            "sub_path": "filament/Bambu ABS @BBL X1E 0.8 nozzle.json"
        },
        {
            "name": "Bambu ABS-GF @base",
            "sub_path": "filament/Bambu ABS-GF @base.json"
        },
        {
            "name": "Bambu ABS-GF @BBL A1",
            "sub_path": "filament/Bambu ABS-GF @BBL A1.json"
        },
        {
            "name": "Bambu ABS-GF @BBL H2D",
            "sub_path": "filament/Bambu ABS-GF @BBL H2D.json"
        },
        {
            "name": "Bambu ABS-GF @BBL P1P",
            "sub_path": "filament/Bambu ABS-GF @BBL P1P.json"
        },
        {
            "name": "Bambu ABS-GF @BBL X1C",
            "sub_path": "filament/Bambu ABS-GF @BBL X1C.json"
        },
        {
            "name": "Bambu Support for ABS @base",
            "sub_path": "filament/Bambu Support for ABS @base.json"
        },
        {
            "name": "Bambu Support for ABS @BBL A1",
            "sub_path": "filament/Bambu Support for ABS @BBL A1.json"
        },
        {
            "name": "Bambu Support for ABS @BBL H2D",
            "sub_path": "filament/Bambu Support for ABS @BBL H2D.json"
        },
        {
            "name": "Bambu Support for ABS @BBL X1C",
            "sub_path": "filament/Bambu Support for ABS @BBL X1C.json"
        },
        {
            "name": "Generic ABS @base",
            "sub_path": "filament/Generic ABS @base.json"
        },
        {
            "name": "Generic ABS",
            "sub_path": "filament/Generic ABS.json"
        },
        {
            "name": "Generic ABS @BBL X1E",
            "sub_path": "filament/Generic ABS @BBL X1E.json"
        },
        {
            "name": "Generic ABS @0.2 nozzle",
            "sub_path": "filament/Generic ABS @0.2 nozzle.json"
        },
        {
            "name": "Generic ABS @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Generic ABS @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Generic ABS @BBL A1",
            "sub_path": "filament/Generic ABS @BBL A1.json"
        },
        {
            "name": "Generic ABS @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic ABS @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic ABS @BBL H2D",
            "sub_path": "filament/Generic ABS @BBL H2D.json"
        },
        {
            "name": "Generic ABS @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic ABS @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic ABS @BBL P1P",
            "sub_path": "filament/P1P/Generic ABS @BBL P1P.json"
        },
        {
            "name": "Generic ABS @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Generic ABS @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ABS @base",
            "sub_path": "filament/PolyLite ABS @base.json"
        },
        {
            "name": "PolyLite ABS @BBL A1",
            "sub_path": "filament/PolyLite ABS @BBL A1.json"
        },
        {
            "name": "PolyLite ABS @BBL A1 0.2 nozzle",
            "sub_path": "filament/PolyLite ABS @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ABS @BBL H2D",
            "sub_path": "filament/PolyLite ABS @BBL H2D.json"
        },
        {
            "name": "PolyLite ABS @BBL H2D 0.2 nozzle",
            "sub_path": "filament/PolyLite ABS @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ABS @BBL P1P",
            "sub_path": "filament/PolyLite ABS @BBL P1P.json"
        },
        {
            "name": "PolyLite ABS @BBL P1P 0.2 nozzle",
            "sub_path": "filament/PolyLite ABS @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ABS @BBL X1C",
            "sub_path": "filament/PolyLite ABS @BBL X1C.json"
        },
        {
            "name": "PolyLite ABS @BBL X1C 0.2 nozzle",
            "sub_path": "filament/PolyLite ABS @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ABS @BBL X1E 0.2 nozzle",
            "sub_path": "filament/PolyLite ABS @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ABS @BBL X1E",
            "sub_path": "filament/PolyLite ABS @BBL X1E.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "Bambu ASA @base",
            "sub_path": "filament/Bambu ASA @base.json"
        },
        {
            "name": "Bambu ASA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu ASA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL A1 0.4 nozzle",
            "sub_path": "filament/Bambu ASA @BBL A1 0.4 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL A1 0.6 nozzle",
            "sub_path": "filament/Bambu ASA @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu ASA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu ASA @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu ASA @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL X1 0.2 nozzle",
            "sub_path": "filament/Bambu ASA @BBL X1 0.2 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL X1 0.6 nozzle",
            "sub_path": "filament/Bambu ASA @BBL X1 0.6 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL X1C",
            "sub_path": "filament/Bambu ASA @BBL X1C.json"
        },
        {
            "name": "Bambu ASA @BBL X1E",
            "sub_path": "filament/Bambu ASA @BBL X1E.json"
        },
        {
            "name": "Bambu ASA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu ASA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Bambu ASA @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL X1C 0.4 nozzle",
            "sub_path": "filament/Bambu ASA @BBL X1C 0.4 nozzle.json"
        },
        {
            "name": "Bambu ASA @BBL X1E 0.4 nozzle",
            "sub_path": "filament/Bambu ASA @BBL X1E 0.4 nozzle.json"
        },
        {
            "name": "Bambu ASA-Aero @base",
            "sub_path": "filament/Bambu ASA-Aero @base.json"
        },
        {
            "name": "Bambu ASA-Aero @BBL A1",
            "sub_path": "filament/Bambu ASA-Aero @BBL A1.json"
        },
        {
            "name": "Bambu ASA-Aero @BBL H2D",
            "sub_path": "filament/Bambu ASA-Aero @BBL H2D.json"
        },
        {
            "name": "Bambu ASA-Aero @BBL P1P",
            "sub_path": "filament/Bambu ASA-Aero @BBL P1P.json"
        },
        {
            "name": "Bambu ASA-Aero @BBL X1C",
            "sub_path": "filament/Bambu ASA-Aero @BBL X1C.json"
        },
        {
            "name": "Bambu ASA-CF @base",
            "sub_path": "filament/Bambu ASA-CF @base.json"
        },
        {
            "name": "Bambu ASA-CF @BBL A1",
            "sub_path": "filament/Bambu ASA-CF @BBL A1.json"
        },
        {
            "name": "Bambu ASA-CF @BBL A1 0.6 nozzle",
            "sub_path": "filament/Bambu ASA-CF @BBL A1 0.6 nozzle.json"
        },
        {
            "name": "Bambu ASA-CF @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu ASA-CF @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu ASA-CF @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu ASA-CF @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu ASA-CF @BBL P1P",
            "sub_path": "filament/Bambu ASA-CF @BBL P1P.json"
        },
        {
            "name": "Bambu ASA-CF @BBL P1P 0.6 nozzle",
            "sub_path": "filament/Bambu ASA-CF @BBL P1P 0.6 nozzle.json"
        },
        {
            "name": "Bambu ASA-CF @BBL X1C",
            "sub_path": "filament/Bambu ASA-CF @BBL X1C.json"
        },
        {
            "name": "Bambu ASA-CF @BBL X1C 0.6 nozzle",
            "sub_path": "filament/Bambu ASA-CF @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "Generic ASA @base",
            "sub_path": "filament/Generic ASA @base.json"
        },
        {
            "name": "Generic ASA",
            "sub_path": "filament/Generic ASA.json"
        },
        {
            "name": "Generic ASA @BBL X1E",
            "sub_path": "filament/Generic ASA @BBL X1E.json"
        },
        {
            "name": "Generic ASA @0.2 nozzle",
            "sub_path": "filament/Generic ASA @0.2 nozzle.json"
        },
        {
            "name": "Generic ASA @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Generic ASA @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Generic ASA @BBL A1",
            "sub_path": "filament/Generic ASA @BBL A1.json"
        },
        {
            "name": "Generic ASA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic ASA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic ASA @BBL H2D",
            "sub_path": "filament/Generic ASA @BBL H2D.json"
        },
        {
            "name": "Generic ASA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic ASA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic ASA @BBL P1P",
            "sub_path": "filament/P1P/Generic ASA @BBL P1P.json"
        },
        {
            "name": "Generic ASA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Generic ASA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ASA @base",
            "sub_path": "filament/PolyLite ASA @base.json"
        },
        {
            "name": "PolyLite ASA @BBL A1",
            "sub_path": "filament/PolyLite ASA @BBL A1.json"
        },
        {
            "name": "PolyLite ASA @BBL A1 0.2 nozzle",
            "sub_path": "filament/PolyLite ASA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ASA @BBL H2D",
            "sub_path": "filament/PolyLite ASA @BBL H2D.json"
        },
        {
            "name": "PolyLite ASA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/PolyLite ASA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ASA @BBL P1P",
            "sub_path": "filament/PolyLite ASA @BBL P1P.json"
        },
        {
            "name": "PolyLite ASA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/PolyLite ASA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ASA @BBL X1C",
            "sub_path": "filament/PolyLite ASA @BBL X1C.json"
        },
        {
            "name": "PolyLite ASA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/PolyLite ASA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "PolyLite ASA @BBL X1E",
            "sub_path": "filament/PolyLite ASA @BBL X1E.json"
        },
        {
            "name": "PolyLite ASA @BBL X1E 0.2 nozzle",
            "sub_path": "filament/PolyLite ASA @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "fdm_filament_bvoh",
            "sub_path": "filament/fdm_filament_bvoh.json"
        },
        {
            "name": "Generic BVOH @base",
            "sub_path": "filament/Generic BVOH @base.json"
        },
        {
            "name": "Generic BVOH @BBL A1",
            "sub_path": "filament/Generic BVOH @BBL A1.json"
        },
        {
            "name": "Generic BVOH @BBL A1M",
            "sub_path": "filament/Generic BVOH @BBL A1M.json"
        },
        {
            "name": "Generic BVOH @BBL H2D",
            "sub_path": "filament/Generic BVOH @BBL H2D.json"
        },
        {
            "name": "Generic BVOH @BBL X1C",
            "sub_path": "filament/Generic BVOH @BBL X1C.json"
        },
        {
            "name": "fdm_filament_eva",
            "sub_path": "filament/fdm_filament_eva.json"
        },
        {
            "name": "Generic EVA @base",
            "sub_path": "filament/Generic EVA @base.json"
        },
        {
            "name": "Generic EVA @BBL A1",
            "sub_path": "filament/Generic EVA @BBL A1.json"
        },
        {
            "name": "Generic EVA @BBL A1M",
            "sub_path": "filament/Generic EVA @BBL A1M.json"
        },
        {
            "name": "Generic EVA @BBL H2D",
            "sub_path": "filament/Generic EVA @BBL H2D.json"
        },
        {
            "name": "Generic EVA @BBL X1C",
            "sub_path": "filament/Generic EVA @BBL X1C.json"
        },
        {
            "name": "fdm_filament_hips",
            "sub_path": "filament/fdm_filament_hips.json"
        },
        {
            "name": "Generic HIPS @base",
            "sub_path": "filament/Generic HIPS @base.json"
        },
        {
            "name": "Generic HIPS @BBL A1",
            "sub_path": "filament/Generic HIPS @BBL A1.json"
        },
        {
            "name": "Generic HIPS @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic HIPS @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic HIPS @BBL A1M",
            "sub_path": "filament/Generic HIPS @BBL A1M.json"
        },
        {
            "name": "Generic HIPS @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Generic HIPS @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Generic HIPS @BBL H2D",
            "sub_path": "filament/Generic HIPS @BBL H2D.json"
        },
        {
            "name": "Generic HIPS @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic HIPS @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic HIPS @BBL X1C",
            "sub_path": "filament/Generic HIPS @BBL X1C.json"
        },
        {
            "name": "Generic HIPS @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Generic HIPS @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_filament_pa",
            "sub_path": "filament/fdm_filament_pa.json"
        },
        {
            "name": "Bambu PA-CF @base",
            "sub_path": "filament/Bambu PA-CF @base.json"
        },
        {
            "name": "Bambu PA-CF @BBL A1",
            "sub_path": "filament/Bambu PA-CF @BBL A1.json"
        },
        {
            "name": "Bambu PA-CF @BBL H2D",
            "sub_path": "filament/Bambu PA-CF @BBL H2D.json"
        },
        {
            "name": "Bambu PA-CF @BBL P1P",
            "sub_path": "filament/P1P/Bambu PA-CF @BBL P1P.json"
        },
        {
            "name": "Bambu PA-CF @BBL X1C",
            "sub_path": "filament/Bambu PA-CF @BBL X1C.json"
        },
        {
            "name": "Bambu PA-CF @BBL X1E",
            "sub_path": "filament/Bambu PA-CF @BBL X1E.json"
        },
        {
            "name": "Bambu PA6-CF @base",
            "sub_path": "filament/Bambu PA6-CF @base.json"
        },
        {
            "name": "Bambu PA6-CF @BBL A1",
            "sub_path": "filament/Bambu PA6-CF @BBL A1.json"
        },
        {
            "name": "Bambu PA6-CF @BBL H2D",
            "sub_path": "filament/Bambu PA6-CF @BBL H2D.json"
        },
        {
            "name": "Bambu PA6-CF @BBL X1C",
            "sub_path": "filament/Bambu PA6-CF @BBL X1C.json"
        },
        {
            "name": "Bambu PA6-CF @BBL X1E",
            "sub_path": "filament/Bambu PA6-CF @BBL X1E.json"
        },
        {
            "name": "Bambu PA6-GF @base",
            "sub_path": "filament/Bambu PA6-GF @base.json"
        },
        {
            "name": "Bambu PA6-GF @BBL A1",
            "sub_path": "filament/Bambu PA6-GF @BBL A1.json"
        },
        {
            "name": "Bambu PA6-GF @BBL H2D",
            "sub_path": "filament/Bambu PA6-GF @BBL H2D.json"
        },
        {
            "name": "Bambu PA6-GF @BBL P1P",
            "sub_path": "filament/Bambu PA6-GF @BBL P1P.json"
        },
        {
            "name": "Bambu PA6-GF @BBL X1C",
            "sub_path": "filament/Bambu PA6-GF @BBL X1C.json"
        },
        {
            "name": "Bambu PAHT-CF @base",
            "sub_path": "filament/Bambu PAHT-CF @base.json"
        },
        {
            "name": "Bambu PAHT-CF @BBL A1",
            "sub_path": "filament/Bambu PAHT-CF @BBL A1.json"
        },
        {
            "name": "Bambu PAHT-CF @BBL H2D",
            "sub_path": "filament/Bambu PAHT-CF @BBL H2D.json"
        },
        {
            "name": "Bambu PAHT-CF @BBL P1P",
            "sub_path": "filament/P1P/Bambu PAHT-CF @BBL P1P.json"
        },
        {
            "name": "Bambu PAHT-CF @BBL X1C",
            "sub_path": "filament/Bambu PAHT-CF @BBL X1C.json"
        },
        {
            "name": "Bambu Support For PA/PET @base",
            "sub_path": "filament/Bambu Support For PA PET @base.json"
        },
        {
            "name": "Bambu Support For PA/PET @BBL A1",
            "sub_path": "filament/Bambu Support For PA PET @BBL A1.json"
        },
        {
            "name": "Bambu Support For PA/PET @BBL H2D",
            "sub_path": "filament/Bambu Support For PA PET @BBL H2D.json"
        },
        {
            "name": "Bambu Support For PA/PET @BBL P1P",
            "sub_path": "filament/P1P/Bambu Support For PA PET @BBL P1P.json"
        },
        {
            "name": "Bambu Support For PA/PET @BBL X1C",
            "sub_path": "filament/Bambu Support For PA PET @BBL X1C.json"
        },
        {
            "name": "Bambu Support G @base",
            "sub_path": "filament/Bambu Support G @base.json"
        },
        {
            "name": "Bambu Support G @BBL A1",
            "sub_path": "filament/Bambu Support G @BBL A1.json"
        },
        {
            "name": "Bambu Support G @BBL H2D",
            "sub_path": "filament/Bambu Support G @BBL H2D.json"
        },
        {
            "name": "Bambu Support G @BBL P1P",
            "sub_path": "filament/P1P/Bambu Support G @BBL P1P.json"
        },
        {
            "name": "Bambu Support G @BBL X1C",
            "sub_path": "filament/Bambu Support G @BBL X1C.json"
        },
        {
            "name": "Bambu Support G @BBL X1E",
            "sub_path": "filament/Bambu Support G @BBL X1E.json"
        },
        {
            "name": "Fiberon PA12-CF @base",
            "sub_path": "filament/Fiberon PA12-CF @base.json"
        },
        {
            "name": "Fiberon PA12-CF @BBL X1C",
            "sub_path": "filament/Fiberon PA12-CF @BBL X1C.json"
        },
        {
            "name": "Fiberon PA6-CF @base",
            "sub_path": "filament/Fiberon PA6-CF @base.json"
        },
        {
            "name": "Fiberon PA6-CF @BBL X1C",
            "sub_path": "filament/Fiberon PA6-CF @BBL X1C.json"
        },
        {
            "name": "Fiberon PA6-GF @base",
            "sub_path": "filament/Fiberon PA6-GF @base.json"
        },
        {
            "name": "Fiberon PA6-GF @BBL X1C",
            "sub_path": "filament/Fiberon PA6-GF @BBL X1C.json"
        },
        {
            "name": "Fiberon PA612-CF @base",
            "sub_path": "filament/Fiberon PA612-CF @base.json"
        },
        {
            "name": "Fiberon PA612-CF @BBL X1C",
            "sub_path": "filament/Fiberon PA612-CF @BBL X1C.json"
        },
        {
            "name": "Generic PA @base",
            "sub_path": "filament/Generic PA @base.json"
        },
        {
            "name": "Generic PA",
            "sub_path": "filament/Generic PA.json"
        },
        {
            "name": "Generic PA @BBL A1",
            "sub_path": "filament/Generic PA @BBL A1.json"
        },
        {
            "name": "Generic PA @BBL H2D",
            "sub_path": "filament/Generic PA @BBL H2D.json"
        },
        {
            "name": "Generic PA @BBL P1P",
            "sub_path": "filament/P1P/Generic PA @BBL P1P.json"
        },
        {
            "name": "Generic PA-CF @base",
            "sub_path": "filament/Generic PA-CF @base.json"
        },
        {
            "name": "Generic PA-CF",
            "sub_path": "filament/Generic PA-CF.json"
        },
        {
            "name": "Generic PA-CF @BBL A1",
            "sub_path": "filament/Generic PA-CF @BBL A1.json"
        },
        {
            "name": "Generic PA-CF @BBL H2D",
            "sub_path": "filament/Generic PA-CF @BBL H2D.json"
        },
        {
            "name": "Generic PA-CF @BBL X1E",
            "sub_path": "filament/Generic PA-CF @BBL X1E.json"
        },
        {
            "name": "Generic PA-CF @BBL P1P",
            "sub_path": "filament/P1P/Generic PA-CF @BBL P1P.json"
        },
        {
            "name": "fdm_filament_pc",
            "sub_path": "filament/fdm_filament_pc.json"
        },
        {
            "name": "Bambu PC @base",
            "sub_path": "filament/Bambu PC @base.json"
        },
        {
            "name": "Bambu PC @BBL A1",
            "sub_path": "filament/Bambu PC @BBL A1.json"
        },
        {
            "name": "Bambu PC @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PC @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PC @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PC @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PC @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PC @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL P1P",
            "sub_path": "filament/P1P/Bambu PC @BBL P1P.json"
        },
        {
            "name": "Bambu PC @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu PC @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL X1C",
            "sub_path": "filament/Bambu PC @BBL X1C.json"
        },
        {
            "name": "Bambu PC @BBL P1S",
            "sub_path": "filament/Bambu PC @BBL P1S.json"
        },
        {
            "name": "Bambu PC @BBL X1E",
            "sub_path": "filament/Bambu PC @BBL X1E.json"
        },
        {
            "name": "Bambu PC @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PC @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL P1S 0.2 nozzle",
            "sub_path": "filament/Bambu PC @BBL P1S 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Bambu PC @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL X1C 0.6 nozzle",
            "sub_path": "filament/Bambu PC @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL P1S 0.6 nozzle",
            "sub_path": "filament/Bambu PC @BBL P1S 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL X1E 0.6 nozzle",
            "sub_path": "filament/Bambu PC @BBL X1E 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PC @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL P1S 0.8 nozzle",
            "sub_path": "filament/Bambu PC @BBL P1S 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC @BBL X1E 0.8 nozzle",
            "sub_path": "filament/Bambu PC @BBL X1E 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC FR @base",
            "sub_path": "filament/Bambu PC FR @base.json"
        },
        {
            "name": "Bambu PC FR @BBL A1",
            "sub_path": "filament/Bambu PC FR @BBL A1.json"
        },
        {
            "name": "Bambu PC FR @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL P1P",
            "sub_path": "filament/Bambu PC FR @BBL P1P.json"
        },
        {
            "name": "Bambu PC FR @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL P1S",
            "sub_path": "filament/Bambu PC FR @BBL P1S.json"
        },
        {
            "name": "Bambu PC FR @BBL P1S 0.2 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL P1S 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL P1S 0.6 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL P1S 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL P1S 0.8 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL P1S 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL X1C",
            "sub_path": "filament/Bambu PC FR @BBL X1C.json"
        },
        {
            "name": "Bambu PC FR @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL X1C 0.6 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL X1C 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL X1E",
            "sub_path": "filament/Bambu PC FR @BBL X1E.json"
        },
        {
            "name": "Bambu PC FR @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL X1E 0.6 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL X1E 0.6 nozzle.json"
        },
        {
            "name": "Bambu PC FR @BBL X1E 0.8 nozzle",
            "sub_path": "filament/Bambu PC FR @BBL X1E 0.8 nozzle.json"
        },
        {
            "name": "Generic PC @base",
            "sub_path": "filament/Generic PC @base.json"
        },
        {
            "name": "Generic PC",
            "sub_path": "filament/Generic PC.json"
        },
        {
            "name": "Generic PC @BBL P1S",
            "sub_path": "filament/Generic PC @BBL P1S.json"
        },
        {
            "name": "Generic PC @BBL X1E",
            "sub_path": "filament/Generic PC @BBL X1E.json"
        },
        {
            "name": "Generic PC @0.2 nozzle",
            "sub_path": "filament/Generic PC @0.2 nozzle.json"
        },
        {
            "name": "Generic PC @BBL P1S 0.2 nozzle",
            "sub_path": "filament/Generic PC @BBL P1S 0.2 nozzle.json"
        },
        {
            "name": "Generic PC @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Generic PC @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Generic PC @BBL A1",
            "sub_path": "filament/Generic PC @BBL A1.json"
        },
        {
            "name": "Generic PC @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic PC @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic PC @BBL H2D",
            "sub_path": "filament/Generic PC @BBL H2D.json"
        },
        {
            "name": "Generic PC @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic PC @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic PC @BBL P1P",
            "sub_path": "filament/P1P/Generic PC @BBL P1P.json"
        },
        {
            "name": "Generic PC @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Generic PC @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "fdm_filament_pctg",
            "sub_path": "filament/fdm_filament_pctg.json"
        },
        {
            "name": "Generic PCTG @base",
            "sub_path": "filament/Generic PCTG @base.json"
        },
        {
            "name": "Generic PCTG @BBL A1",
            "sub_path": "filament/Generic PCTG @BBL A1.json"
        },
        {
            "name": "Generic PCTG @BBL A1M",
            "sub_path": "filament/Generic PCTG @BBL A1M.json"
        },
        {
            "name": "Generic PCTG @BBL H2D",
            "sub_path": "filament/Generic PCTG @BBL H2D.json"
        },
        {
            "name": "Generic PCTG @BBL X1C",
            "sub_path": "filament/Generic PCTG @BBL X1C.json"
        },
        {
            "name": "fdm_filament_pe",
            "sub_path": "filament/fdm_filament_pe.json"
        },
        {
            "name": "Generic PE @base",
            "sub_path": "filament/Generic PE @base.json"
        },
        {
            "name": "Generic PE @BBL A1",
            "sub_path": "filament/Generic PE @BBL A1.json"
        },
        {
            "name": "Generic PE @BBL A1M",
            "sub_path": "filament/Generic PE @BBL A1M.json"
        },
        {
            "name": "Generic PE @BBL H2D",
            "sub_path": "filament/Generic PE @BBL H2D.json"
        },
        {
            "name": "Generic PE @BBL X1C",
            "sub_path": "filament/Generic PE @BBL X1C.json"
        },
        {
            "name": "Generic PE-CF @base",
            "sub_path": "filament/Generic PE-CF @base.json"
        },
        {
            "name": "Generic PE-CF @BBL A1",
            "sub_path": "filament/Generic PE-CF @BBL A1.json"
        },
        {
            "name": "Generic PE-CF @BBL A1M",
            "sub_path": "filament/Generic PE-CF @BBL A1M.json"
        },
        {
            "name": "Generic PE-CF @BBL H2D",
            "sub_path": "filament/Generic PE-CF @BBL H2D.json"
        },
        {
            "name": "Generic PE-CF @BBL X1C",
            "sub_path": "filament/Generic PE-CF @BBL X1C.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "Bambu PET-CF @base",
            "sub_path": "filament/Bambu PET-CF @base.json"
        },
        {
            "name": "Bambu PET-CF @BBL A1",
            "sub_path": "filament/Bambu PET-CF @BBL A1.json"
        },
        {
            "name": "Bambu PET-CF @BBL H2D",
            "sub_path": "filament/Bambu PET-CF @BBL H2D.json"
        },
        {
            "name": "Bambu PET-CF @BBL P1P",
            "sub_path": "filament/P1P/Bambu PET-CF @BBL P1P.json"
        },
        {
            "name": "Bambu PET-CF @BBL X1C",
            "sub_path": "filament/Bambu PET-CF @BBL X1C.json"
        },
        {
            "name": "Bambu PET-CF @BBL X1E",
            "sub_path": "filament/Bambu PET-CF @BBL X1E.json"
        },
        {
            "name": "Bambu PETG Basic @base",
            "sub_path": "filament/Bambu PETG Basic @base.json"
        },
        {
            "name": "Bambu PETG Basic @BBL A1",
            "sub_path": "filament/Bambu PETG Basic @BBL A1.json"
        },
        {
            "name": "Bambu PETG Basic @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL A1 0.8 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL X1C",
            "sub_path": "filament/Bambu PETG Basic @BBL X1C.json"
        },
        {
            "name": "Bambu PETG Basic @BBL A1M 0.4 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL A1M 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG Basic @BBL A1M 0.8 nozzle",
            "sub_path": "filament/Bambu PETG Basic @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @base",
            "sub_path": "filament/Bambu PETG HF @base.json"
        },
        {
            "name": "Bambu PETG HF @BBL A1",
            "sub_path": "filament/Bambu PETG HF @BBL A1.json"
        },
        {
            "name": "Bambu PETG HF @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL A1 0.8 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL A1M",
            "sub_path": "filament/Bambu PETG HF @BBL A1M.json"
        },
        {
            "name": "Bambu PETG HF @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL A1M 0.8 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL X1C",
            "sub_path": "filament/Bambu PETG HF @BBL X1C.json"
        },
        {
            "name": "Bambu PETG HF @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG HF @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PETG HF @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @base",
            "sub_path": "filament/Bambu PETG Translucent @base.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL A1",
            "sub_path": "filament/Bambu PETG Translucent @BBL A1.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL A1 0.8 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL A1M",
            "sub_path": "filament/Bambu PETG Translucent @BBL A1M.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL A1M 0.8 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL X1C",
            "sub_path": "filament/Bambu PETG Translucent @BBL X1C.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PETG Translucent @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PETG Translucent @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @base",
            "sub_path": "filament/Bambu PETG-CF @base.json"
        },
        {
            "name": "Bambu PETG-CF @BBL A1 0.4 nozzle",
            "sub_path": "filament/Bambu PETG-CF @BBL A1 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @BBL A1 0.8 nozzle",
            "sub_path": "filament/Bambu PETG-CF @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @BBL A1M",
            "sub_path": "filament/Bambu PETG-CF @BBL A1M.json"
        },
        {
            "name": "Bambu PETG-CF @BBL A1M 0.4 nozzle",
            "sub_path": "filament/Bambu PETG-CF @BBL A1M 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PETG-CF @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PETG-CF @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @BBL P1P",
            "sub_path": "filament/P1P/Bambu PETG-CF @BBL P1P.json"
        },
        {
            "name": "Bambu PETG-CF @BBL P1P 0.4 nozzle",
            "sub_path": "filament/P1P/Bambu PETG-CF @BBL P1P 0.4 nozzle.json"
        },
        {
            "name": "Bambu PETG-CF @BBL X1C",
            "sub_path": "filament/Bambu PETG-CF @BBL X1C.json"
        },
        {
            "name": "Bambu PETG-CF @BBL X1C 0.4 nozzle",
            "sub_path": "filament/Bambu PETG-CF @BBL X1C 0.4 nozzle.json"
        },
        {
            "name": "Fiberon PET-CF @base",
            "sub_path": "filament/Fiberon PET-CF @base.json"
        },
        {
            "name": "Fiberon PET-CF @BBL X1C",
            "sub_path": "filament/Fiberon PET-CF @BBL X1C.json"
        },
        {
            "name": "Fiberon PETG-ESD @base",
            "sub_path": "filament/Fiberon PETG-ESD @base.json"
        },
        {
            "name": "Fiberon PETG-ESD @BBL X1C",
            "sub_path": "filament/Fiberon PETG-ESD @BBL X1C.json"
        },
        {
            "name": "Fiberon PETG-rCF @base",
            "sub_path": "filament/Fiberon PETG-rCF @base.json"
        },
        {
            "name": "Fiberon PETG-rCF @BBL X1C",
            "sub_path": "filament/Fiberon PETG-rCF @BBL X1C.json"
        },
        {
            "name": "Generic PETG @base",
            "sub_path": "filament/Generic PETG @base.json"
        },
        {
            "name": "Generic PETG",
            "sub_path": "filament/Generic PETG.json"
        },
        {
            "name": "Generic PETG @0.2 nozzle",
            "sub_path": "filament/Generic PETG @0.2 nozzle.json"
        },
        {
            "name": "Generic PETG @BBL A1",
            "sub_path": "filament/Generic PETG @BBL A1.json"
        },
        {
            "name": "Generic PETG @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic PETG @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG @BBL A1M",
            "sub_path": "filament/Generic PETG @BBL A1M.json"
        },
        {
            "name": "Generic PETG @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Generic PETG @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG @BBL H2D",
            "sub_path": "filament/Generic PETG @BBL H2D.json"
        },
        {
            "name": "Generic PETG @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic PETG @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG @BBL P1P",
            "sub_path": "filament/P1P/Generic PETG @BBL P1P.json"
        },
        {
            "name": "Generic PETG @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Generic PETG @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG HF @base",
            "sub_path": "filament/Generic PETG HF @base.json"
        },
        {
            "name": "Generic PETG HF @BBL A1",
            "sub_path": "filament/Generic PETG HF @BBL A1.json"
        },
        {
            "name": "Generic PETG HF @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic PETG HF @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG HF @BBL A1M",
            "sub_path": "filament/Generic PETG HF @BBL A1M.json"
        },
        {
            "name": "Generic PETG HF @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Generic PETG HF @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG HF @BBL H2D",
            "sub_path": "filament/Generic PETG HF @BBL H2D.json"
        },
        {
            "name": "Generic PETG HF @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic PETG HF @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG HF @BBL P1P",
            "sub_path": "filament/Generic PETG HF @BBL P1P.json"
        },
        {
            "name": "Generic PETG HF @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Generic PETG HF @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG HF @BBL X1C",
            "sub_path": "filament/Generic PETG HF @BBL X1C.json"
        },
        {
            "name": "Generic PETG HF @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Generic PETG HF @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Generic PETG-CF @base",
            "sub_path": "filament/Generic PETG-CF @base.json"
        },
        {
            "name": "Generic PETG-CF @BBL A1",
            "sub_path": "filament/Generic PETG-CF @BBL A1.json"
        },
        {
            "name": "Generic PETG-CF @BBL H2D",
            "sub_path": "filament/Generic PETG-CF @BBL H2D.json"
        },
        {
            "name": "Generic PETG-CF @BBL P1P",
            "sub_path": "filament/P1P/Generic PETG-CF @BBL P1P.json"
        },
        {
            "name": "Generic PETG-CF @BBL A1M",
            "sub_path": "filament/P1P/Generic PETG-CF @BBL A1M.json"
        },
        {
            "name": "Generic PETG-CF @BBL X1C",
            "sub_path": "filament/Generic PETG-CF @BBL X1C.json"
        },
        {
            "name": "PolyLite PETG @base",
            "sub_path": "filament/PolyLite PETG @base.json"
        },
        {
            "name": "PolyLite PETG @BBL A1",
            "sub_path": "filament/PolyLite PETG @BBL A1.json"
        },
        {
            "name": "PolyLite PETG @BBL A1 0.2 nozzle",
            "sub_path": "filament/PolyLite PETG @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PETG @BBL A1M",
            "sub_path": "filament/PolyLite PETG @BBL A1M.json"
        },
        {
            "name": "PolyLite PETG @BBL A1M 0.2 nozzle",
            "sub_path": "filament/PolyLite PETG @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PETG @BBL H2D",
            "sub_path": "filament/PolyLite PETG @BBL H2D.json"
        },
        {
            "name": "PolyLite PETG @BBL H2D 0.2 nozzle",
            "sub_path": "filament/PolyLite PETG @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PETG @BBL P1P",
            "sub_path": "filament/PolyLite PETG @BBL P1P.json"
        },
        {
            "name": "PolyLite PETG @BBL P1P 0.2 nozzle",
            "sub_path": "filament/PolyLite PETG @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PETG @BBL X1C",
            "sub_path": "filament/PolyLite PETG @BBL X1C.json"
        },
        {
            "name": "PolyLite PETG @BBL X1C 0.2 nozzle",
            "sub_path": "filament/PolyLite PETG @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PETG @base",
            "sub_path": "filament/SUNLU/SUNLU PETG @base.json"
        },
        {
            "name": "SUNLU PETG @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL A1.json"
        },
        {
            "name": "SUNLU PETG @BBL A1 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PETG @BBL A1 0.8 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "SUNLU PETG @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL X1C.json"
        },
        {
            "name": "SUNLU PETG @BBL A1M 0.4 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL A1M.json"
        },
        {
            "name": "SUNLU PETG @BBL X1C 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PETG @BBL A1M 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PETG @BBL X1C 0.8 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "SUNLU PETG @BBL A1M 0.8 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PETG @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "fdm_filament_pha",
            "sub_path": "filament/fdm_filament_pha.json"
        },
        {
            "name": "Generic PHA @base",
            "sub_path": "filament/Generic PHA @base.json"
        },
        {
            "name": "Generic PHA @BBL A1",
            "sub_path": "filament/Generic PHA @BBL A1.json"
        },
        {
            "name": "Generic PHA @BBL A1M",
            "sub_path": "filament/Generic PHA @BBL A1M.json"
        },
        {
            "name": "Generic PHA @BBL H2D",
            "sub_path": "filament/Generic PHA @BBL H2D.json"
        },
        {
            "name": "Generic PHA @BBL X1C",
            "sub_path": "filament/Generic PHA @BBL X1C.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "Bambu PLA Aero @base",
            "sub_path": "filament/Bambu PLA Aero @base.json"
        },
        {
            "name": "Bambu PLA Aero @BBL A1",
            "sub_path": "filament/Bambu PLA Aero @BBL A1.json"
        },
        {
            "name": "Bambu PLA Aero @BBL A1M",
            "sub_path": "filament/Bambu PLA Aero @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Aero @BBL H2D",
            "sub_path": "filament/Bambu PLA Aero @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Aero @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Aero @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Aero @BBL X1",
            "sub_path": "filament/Bambu PLA Aero @BBL X1.json"
        },
        {
            "name": "Bambu PLA Aero @BBL X1C",
            "sub_path": "filament/Bambu PLA Aero @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Basic @base",
            "sub_path": "filament/Bambu PLA Basic @base.json"
        },
        {
            "name": "Bambu PLA Basic @BBL A1",
            "sub_path": "filament/Bambu PLA Basic @BBL A1.json"
        },
        {
            "name": "Bambu PLA Basic @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Basic @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Basic @BBL A1M",
            "sub_path": "filament/Bambu PLA Basic @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Basic @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Basic @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Basic @BBL H2D",
            "sub_path": "filament/Bambu PLA Basic @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Basic @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Basic @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Basic @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Basic @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Basic @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Basic @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Basic @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu PLA Basic @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Basic @BBL X1",
            "sub_path": "filament/Bambu PLA Basic @BBL X1.json"
        },
        {
            "name": "Bambu PLA Basic @BBL X1C",
            "sub_path": "filament/Bambu PLA Basic @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Basic @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Basic @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Basic @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Basic @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @base",
            "sub_path": "filament/Bambu PLA Dynamic @base.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL A1",
            "sub_path": "filament/Bambu PLA Dynamic @BBL A1.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL A1M",
            "sub_path": "filament/Bambu PLA Dynamic @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL H2D",
            "sub_path": "filament/Bambu PLA Dynamic @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL P1P",
            "sub_path": "filament/Bambu PLA Dynamic @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL X1C",
            "sub_path": "filament/Bambu PLA Dynamic @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Dynamic @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Dynamic @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @base",
            "sub_path": "filament/Bambu PLA Galaxy @base.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL A1",
            "sub_path": "filament/Bambu PLA Galaxy @BBL A1.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL A1M",
            "sub_path": "filament/Bambu PLA Galaxy @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL H2D",
            "sub_path": "filament/Bambu PLA Galaxy @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL P1P",
            "sub_path": "filament/Bambu PLA Galaxy @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL X1C",
            "sub_path": "filament/Bambu PLA Galaxy @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Galaxy @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Galaxy @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @base",
            "sub_path": "filament/Bambu PLA Glow @base.json"
        },
        {
            "name": "Bambu PLA Glow @BBL A1",
            "sub_path": "filament/Bambu PLA Glow @BBL A1.json"
        },
        {
            "name": "Bambu PLA Glow @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @BBL A1M",
            "sub_path": "filament/Bambu PLA Glow @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Glow @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @BBL H2D",
            "sub_path": "filament/Bambu PLA Glow @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Glow @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @BBL P1P",
            "sub_path": "filament/Bambu PLA Glow @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Glow @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @BBL X1",
            "sub_path": "filament/Bambu PLA Glow @BBL X1.json"
        },
        {
            "name": "Bambu PLA Glow @BBL X1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL X1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @BBL X1C",
            "sub_path": "filament/Bambu PLA Glow @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Glow @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Glow @BBL X1E",
            "sub_path": "filament/Bambu PLA Glow @BBL X1E.json"
        },
        {
            "name": "Bambu PLA Glow @BBL X1E 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Glow @BBL X1E 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @base",
            "sub_path": "filament/Bambu PLA Lite @base.json"
        },
        {
            "name": "Bambu PLA Lite @BBL A1",
            "sub_path": "filament/Bambu PLA Lite @BBL A1.json"
        },
        {
            "name": "Bambu PLA Lite @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @BBL A1M",
            "sub_path": "filament/Bambu PLA Lite @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Lite @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @BBL H2D",
            "sub_path": "filament/Bambu PLA Lite @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Lite @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @BBL P1P",
            "sub_path": "filament/Bambu PLA Lite @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Lite @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @BBL X1C",
            "sub_path": "filament/Bambu PLA Lite @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Lite @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Lite @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Lite @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Marble @base",
            "sub_path": "filament/Bambu PLA Marble @base.json"
        },
        {
            "name": "Bambu PLA Marble @BBL A1",
            "sub_path": "filament/Bambu PLA Marble @BBL A1.json"
        },
        {
            "name": "Bambu PLA Marble @BBL A1M",
            "sub_path": "filament/Bambu PLA Marble @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Marble @BBL H2D",
            "sub_path": "filament/Bambu PLA Marble @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Marble @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Marble @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Marble @BBL X1",
            "sub_path": "filament/Bambu PLA Marble @BBL X1.json"
        },
        {
            "name": "Bambu PLA Marble @BBL X1C",
            "sub_path": "filament/Bambu PLA Marble @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Matte @base",
            "sub_path": "filament/Bambu PLA Matte @base.json"
        },
        {
            "name": "Bambu PLA Matte @BBL A1",
            "sub_path": "filament/Bambu PLA Matte @BBL A1.json"
        },
        {
            "name": "Bambu PLA Matte @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Matte @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Matte @BBL A1M",
            "sub_path": "filament/Bambu PLA Matte @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Matte @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Matte @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Matte @BBL H2D",
            "sub_path": "filament/Bambu PLA Matte @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Matte @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Matte @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Matte @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Matte @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Matte @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Matte @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Matte @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu PLA Matte @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Matte @BBL X1",
            "sub_path": "filament/Bambu PLA Matte @BBL X1.json"
        },
        {
            "name": "Bambu PLA Matte @BBL X1C",
            "sub_path": "filament/Bambu PLA Matte @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Matte @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Matte @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Matte @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Matte @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Metal @base",
            "sub_path": "filament/Bambu PLA Metal @base.json"
        },
        {
            "name": "Bambu PLA Metal @BBL A1",
            "sub_path": "filament/Bambu PLA Metal @BBL A1.json"
        },
        {
            "name": "Bambu PLA Metal @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Metal @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Metal @BBL A1M",
            "sub_path": "filament/Bambu PLA Metal @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Metal @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Metal @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Metal @BBL H2D",
            "sub_path": "filament/Bambu PLA Metal @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Metal @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Metal @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Metal @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Metal @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Metal @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu PLA Metal @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Metal @BBL X1",
            "sub_path": "filament/Bambu PLA Metal @BBL X1.json"
        },
        {
            "name": "Bambu PLA Metal @BBL X1C",
            "sub_path": "filament/Bambu PLA Metal @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Metal @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Metal @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk @base",
            "sub_path": "filament/Bambu PLA Silk @base.json"
        },
        {
            "name": "Bambu PLA Silk @BBL A1",
            "sub_path": "filament/Bambu PLA Silk @BBL A1.json"
        },
        {
            "name": "Bambu PLA Silk @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk @BBL A1M",
            "sub_path": "filament/Bambu PLA Silk @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Silk @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk @BBL H2D",
            "sub_path": "filament/Bambu PLA Silk @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Silk @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Silk @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Silk @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu PLA Silk @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk @BBL X1",
            "sub_path": "filament/Bambu PLA Silk @BBL X1.json"
        },
        {
            "name": "Bambu PLA Silk @BBL X1C",
            "sub_path": "filament/Bambu PLA Silk @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Silk @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk+ @base",
            "sub_path": "filament/Bambu PLA Silk+ @base.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL A1",
            "sub_path": "filament/Bambu PLA Silk+ @BBL A1.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk+ @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL A1M",
            "sub_path": "filament/Bambu PLA Silk+ @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk+ @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL H2D",
            "sub_path": "filament/Bambu PLA Silk+ @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk+ @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL P1P",
            "sub_path": "filament/Bambu PLA Silk+ @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk+ @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL X1",
            "sub_path": "filament/Bambu PLA Silk+ @BBL X1.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL X1C",
            "sub_path": "filament/Bambu PLA Silk+ @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Silk+ @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Silk+ @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Sparkle @base",
            "sub_path": "filament/Bambu PLA Sparkle @base.json"
        },
        {
            "name": "Bambu PLA Sparkle @BBL A1",
            "sub_path": "filament/Bambu PLA Sparkle @BBL A1.json"
        },
        {
            "name": "Bambu PLA Sparkle @BBL A1M",
            "sub_path": "filament/Bambu PLA Sparkle @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Sparkle @BBL H2D",
            "sub_path": "filament/Bambu PLA Sparkle @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Sparkle @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Sparkle @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Sparkle @BBL X1",
            "sub_path": "filament/Bambu PLA Sparkle @BBL X1.json"
        },
        {
            "name": "Bambu PLA Sparkle @BBL X1C",
            "sub_path": "filament/Bambu PLA Sparkle @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Tough @base",
            "sub_path": "filament/Bambu PLA Tough @base.json"
        },
        {
            "name": "Bambu PLA Tough @BBL A1",
            "sub_path": "filament/Bambu PLA Tough @BBL A1.json"
        },
        {
            "name": "Bambu PLA Tough @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Tough @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Tough @BBL A1M",
            "sub_path": "filament/Bambu PLA Tough @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Tough @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Tough @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Tough @BBL H2D",
            "sub_path": "filament/Bambu PLA Tough @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Tough @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Tough @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Tough @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA Tough @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Tough @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu PLA Tough @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Tough @BBL X1",
            "sub_path": "filament/Bambu PLA Tough @BBL X1.json"
        },
        {
            "name": "Bambu PLA Tough @BBL X1C",
            "sub_path": "filament/Bambu PLA Tough @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Tough @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Tough @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @base",
            "sub_path": "filament/Bambu PLA Translucent @base.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL A1",
            "sub_path": "filament/Bambu PLA Translucent @BBL A1.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL A1 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL A1M",
            "sub_path": "filament/Bambu PLA Translucent @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL A1M 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL H2D",
            "sub_path": "filament/Bambu PLA Translucent @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL P1P",
            "sub_path": "filament/Bambu PLA Translucent @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL P1P 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL X1C",
            "sub_path": "filament/Bambu PLA Translucent @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu PLA Translucent @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Translucent @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Wood @base",
            "sub_path": "filament/Bambu PLA Wood @base.json"
        },
        {
            "name": "Bambu PLA Wood @BBL A1",
            "sub_path": "filament/Bambu PLA Wood @BBL A1.json"
        },
        {
            "name": "Bambu PLA Wood @BBL A1M",
            "sub_path": "filament/Bambu PLA Wood @BBL A1M.json"
        },
        {
            "name": "Bambu PLA Wood @BBL H2D",
            "sub_path": "filament/Bambu PLA Wood @BBL H2D.json"
        },
        {
            "name": "Bambu PLA Wood @BBL H2D 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Wood @BBL H2D 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA Wood @BBL P1P",
            "sub_path": "filament/Bambu PLA Wood @BBL P1P.json"
        },
        {
            "name": "Bambu PLA Wood @BBL X1",
            "sub_path": "filament/Bambu PLA Wood @BBL X1.json"
        },
        {
            "name": "Bambu PLA Wood @BBL X1C",
            "sub_path": "filament/Bambu PLA Wood @BBL X1C.json"
        },
        {
            "name": "Bambu PLA Wood @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA Wood @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA-CF @base",
            "sub_path": "filament/Bambu PLA-CF @base.json"
        },
        {
            "name": "Bambu PLA-CF @BBL A1",
            "sub_path": "filament/Bambu PLA-CF @BBL A1.json"
        },
        {
            "name": "Bambu PLA-CF @BBL A1 0.8 nozzle",
            "sub_path": "filament/Bambu PLA-CF @BBL A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA-CF @BBL A1M",
            "sub_path": "filament/Bambu PLA-CF @BBL A1M.json"
        },
        {
            "name": "Bambu PLA-CF @BBL A1M 0.8 nozzle",
            "sub_path": "filament/Bambu PLA-CF @BBL A1M 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA-CF @BBL H2D 0.4 nozzle",
            "sub_path": "filament/Bambu PLA-CF @BBL H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu PLA-CF @BBL H2D 0.6 nozzle",
            "sub_path": "filament/Bambu PLA-CF @BBL H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu PLA-CF @BBL P1P",
            "sub_path": "filament/P1P/Bambu PLA-CF @BBL P1P.json"
        },
        {
            "name": "Bambu PLA-CF @BBL P1P 0.8 nozzle",
            "sub_path": "filament/P1P/Bambu PLA-CF @BBL P1P 0.8 nozzle.json"
        },
        {
            "name": "Bambu PLA-CF @BBL X1C",
            "sub_path": "filament/Bambu PLA-CF @BBL X1C.json"
        },
        {
            "name": "Bambu PLA-CF @BBL X1C 0.8 nozzle",
            "sub_path": "filament/Bambu PLA-CF @BBL X1C 0.8 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA @base",
            "sub_path": "filament/Bambu Support For PLA @base.json"
        },
        {
            "name": "Bambu Support For PLA @BBL A1",
            "sub_path": "filament/Bambu Support For PLA @BBL A1.json"
        },
        {
            "name": "Bambu Support For PLA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA @BBL A1M",
            "sub_path": "filament/Bambu Support For PLA @BBL A1M.json"
        },
        {
            "name": "Bambu Support For PLA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA @BBL H2D",
            "sub_path": "filament/Bambu Support For PLA @BBL H2D.json"
        },
        {
            "name": "Bambu Support For PLA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA @BBL P1P",
            "sub_path": "filament/P1P/Bambu Support For PLA @BBL P1P.json"
        },
        {
            "name": "Bambu Support For PLA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu Support For PLA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA @BBL X1C",
            "sub_path": "filament/Bambu Support For PLA @BBL X1C.json"
        },
        {
            "name": "Bambu Support For PLA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @base",
            "sub_path": "filament/Bambu Support For PLA-PETG @base.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL A1",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL A1.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL A1M",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL A1M.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL H2D",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL H2D.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL P1P",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL P1P.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL X1C",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL X1C.json"
        },
        {
            "name": "Bambu Support For PLA/PETG @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu Support For PLA-PETG @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support W @base",
            "sub_path": "filament/Bambu Support W @base.json"
        },
        {
            "name": "Bambu Support W @BBL A1",
            "sub_path": "filament/Bambu Support W @BBL A1.json"
        },
        {
            "name": "Bambu Support W @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu Support W @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support W @BBL A1M",
            "sub_path": "filament/Bambu Support W @BBL A1M.json"
        },
        {
            "name": "Bambu Support W @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu Support W @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support W @BBL H2D",
            "sub_path": "filament/Bambu Support W @BBL H2D.json"
        },
        {
            "name": "Bambu Support W @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu Support W @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support W @BBL P1P",
            "sub_path": "filament/P1P/Bambu Support W @BBL P1P.json"
        },
        {
            "name": "Bambu Support W @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Bambu Support W @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu Support W @BBL X1",
            "sub_path": "filament/Bambu Support W @BBL X1.json"
        },
        {
            "name": "Bambu Support W @BBL X1C",
            "sub_path": "filament/Bambu Support W @BBL X1C.json"
        },
        {
            "name": "Bambu Support W @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu Support W @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA @base",
            "sub_path": "filament/Generic PLA @base.json"
        },
        {
            "name": "Generic PLA",
            "sub_path": "filament/Generic PLA.json"
        },
        {
            "name": "Generic PLA @0.2 nozzle",
            "sub_path": "filament/Generic PLA @0.2 nozzle.json"
        },
        {
            "name": "Generic PLA @BBL A1",
            "sub_path": "filament/Generic PLA @BBL A1.json"
        },
        {
            "name": "Generic PLA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic PLA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA @BBL A1M",
            "sub_path": "filament/Generic PLA @BBL A1M.json"
        },
        {
            "name": "Generic PLA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Generic PLA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA @BBL H2D",
            "sub_path": "filament/Generic PLA @BBL H2D.json"
        },
        {
            "name": "Generic PLA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic PLA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA @BBL P1P",
            "sub_path": "filament/P1P/Generic PLA @BBL P1P.json"
        },
        {
            "name": "Generic PLA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Generic PLA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA High Speed @base",
            "sub_path": "filament/Generic PLA High Speed @base.json"
        },
        {
            "name": "Generic PLA High Speed @BBL A1",
            "sub_path": "filament/Generic PLA High Speed @BBL A1.json"
        },
        {
            "name": "Generic PLA High Speed @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic PLA High Speed @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA High Speed @BBL A1M",
            "sub_path": "filament/Generic PLA High Speed @BBL A1M.json"
        },
        {
            "name": "Generic PLA High Speed @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Generic PLA High Speed @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA High Speed @BBL H2D",
            "sub_path": "filament/Generic PLA High Speed @BBL H2D.json"
        },
        {
            "name": "Generic PLA High Speed @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic PLA High Speed @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA High Speed @BBL P1P",
            "sub_path": "filament/Generic PLA High Speed @BBL P1P.json"
        },
        {
            "name": "Generic PLA High Speed @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Generic PLA High Speed @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA High Speed @BBL X1C",
            "sub_path": "filament/Generic PLA High Speed @BBL X1C.json"
        },
        {
            "name": "Generic PLA High Speed @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Generic PLA High Speed @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Generic PLA Silk @base",
            "sub_path": "filament/Generic PLA Silk @base.json"
        },
        {
            "name": "Generic PLA Silk",
            "sub_path": "filament/Generic PLA Silk.json"
        },
        {
            "name": "Generic PLA Silk @BBL A1",
            "sub_path": "filament/Generic PLA Silk @BBL A1.json"
        },
        {
            "name": "Generic PLA Silk @BBL A1M",
            "sub_path": "filament/Generic PLA Silk @BBL A1M.json"
        },
        {
            "name": "Generic PLA Silk @BBL H2D",
            "sub_path": "filament/Generic PLA Silk @BBL H2D.json"
        },
        {
            "name": "Generic PLA Silk @BBL P1P",
            "sub_path": "filament/P1P/Generic PLA Silk @BBL P1P.json"
        },
        {
            "name": "Generic PLA-CF @base",
            "sub_path": "filament/Generic PLA-CF @base.json"
        },
        {
            "name": "Generic PLA-CF",
            "sub_path": "filament/Generic PLA-CF.json"
        },
        {
            "name": "Generic PLA-CF @BBL A1",
            "sub_path": "filament/Generic PLA-CF @BBL A1.json"
        },
        {
            "name": "Generic PLA-CF @BBL A1M",
            "sub_path": "filament/Generic PLA-CF @BBL A1M.json"
        },
        {
            "name": "Generic PLA-CF @BBL H2D",
            "sub_path": "filament/Generic PLA-CF @BBL H2D.json"
        },
        {
            "name": "Generic PLA-CF @BBL P1P",
            "sub_path": "filament/P1P/Generic PLA-CF @BBL P1P.json"
        },
        {
            "name": "Overture Matte PLA @base",
            "sub_path": "filament/Overture Matte PLA @base.json"
        },
        {
            "name": "Overture Matte PLA @BBL A1",
            "sub_path": "filament/Overture Matte PLA @BBL A1.json"
        },
        {
            "name": "Overture Matte PLA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Overture Matte PLA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Overture Matte PLA @BBL A1M",
            "sub_path": "filament/Overture Matte PLA @BBL A1M.json"
        },
        {
            "name": "Overture Matte PLA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Overture Matte PLA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Overture Matte PLA @BBL H2D",
            "sub_path": "filament/Overture Matte PLA @BBL H2D.json"
        },
        {
            "name": "Overture Matte PLA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Overture Matte PLA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Overture Matte PLA @BBL P1P",
            "sub_path": "filament/Overture Matte PLA @BBL P1P.json"
        },
        {
            "name": "Overture Matte PLA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Overture Matte PLA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Overture Matte PLA @BBL X1",
            "sub_path": "filament/Overture Matte PLA @BBL X1.json"
        },
        {
            "name": "Overture Matte PLA @BBL X1C",
            "sub_path": "filament/Overture Matte PLA @BBL X1C.json"
        },
        {
            "name": "Overture Matte PLA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Overture Matte PLA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Overture PLA @base",
            "sub_path": "filament/Overture PLA @base.json"
        },
        {
            "name": "Overture PLA @BBL A1",
            "sub_path": "filament/Overture PLA @BBL A1.json"
        },
        {
            "name": "Overture PLA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Overture PLA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Overture PLA @BBL A1M",
            "sub_path": "filament/Overture PLA @BBL A1M.json"
        },
        {
            "name": "Overture PLA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Overture PLA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Overture PLA @BBL H2D",
            "sub_path": "filament/Overture PLA @BBL H2D.json"
        },
        {
            "name": "Overture PLA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Overture PLA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Overture PLA @BBL P1P",
            "sub_path": "filament/Overture PLA @BBL P1P.json"
        },
        {
            "name": "Overture PLA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Overture PLA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Overture PLA @BBL X1",
            "sub_path": "filament/Overture PLA @BBL X1.json"
        },
        {
            "name": "Overture PLA @BBL X1C",
            "sub_path": "filament/Overture PLA @BBL X1C.json"
        },
        {
            "name": "Overture PLA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Overture PLA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PLA @base",
            "sub_path": "filament/PolyLite PLA @base.json"
        },
        {
            "name": "PolyLite PLA @BBL A1",
            "sub_path": "filament/PolyLite PLA @BBL A1.json"
        },
        {
            "name": "PolyLite PLA @BBL A1 0.2 nozzle",
            "sub_path": "filament/PolyLite PLA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PLA @BBL A1M",
            "sub_path": "filament/PolyLite PLA @BBL A1M.json"
        },
        {
            "name": "PolyLite PLA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/PolyLite PLA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PLA @BBL H2D",
            "sub_path": "filament/PolyLite PLA @BBL H2D.json"
        },
        {
            "name": "PolyLite PLA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/PolyLite PLA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PLA @BBL P1P",
            "sub_path": "filament/P1P/PolyLite PLA @BBL P1P.json"
        },
        {
            "name": "PolyLite PLA @BBL X1",
            "sub_path": "filament/PolyLite PLA @BBL X1.json"
        },
        {
            "name": "PolyLite PLA @BBL X1C",
            "sub_path": "filament/PolyLite PLA @BBL X1C.json"
        },
        {
            "name": "PolyLite PLA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/PolyLite PLA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyLite PLA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/PolyLite PLA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "PolyTerra PLA @base",
            "sub_path": "filament/PolyTerra PLA @base.json"
        },
        {
            "name": "PolyTerra PLA @BBL A1",
            "sub_path": "filament/PolyTerra PLA @BBL A1.json"
        },
        {
            "name": "PolyTerra PLA @BBL A1 0.2 nozzle",
            "sub_path": "filament/PolyTerra PLA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "PolyTerra PLA @BBL A1M",
            "sub_path": "filament/PolyTerra PLA @BBL A1M.json"
        },
        {
            "name": "PolyTerra PLA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/PolyTerra PLA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "PolyTerra PLA @BBL H2D",
            "sub_path": "filament/PolyTerra PLA @BBL H2D.json"
        },
        {
            "name": "PolyTerra PLA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/PolyTerra PLA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "PolyTerra PLA @BBL P1P",
            "sub_path": "filament/P1P/PolyTerra PLA @BBL P1P.json"
        },
        {
            "name": "PolyTerra PLA @BBL X1",
            "sub_path": "filament/PolyTerra PLA @BBL X1.json"
        },
        {
            "name": "PolyTerra PLA @BBL X1C",
            "sub_path": "filament/PolyTerra PLA @BBL X1C.json"
        },
        {
            "name": "PolyTerra PLA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/PolyTerra PLA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "PolyTerra PLA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/PolyTerra PLA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA Marble @base",
            "sub_path": "filament/SUNLU/SUNLU Marble PLA @base.json"
        },
        {
            "name": "SUNLU PLA Marble @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU Marble PLA @BBL A1.json"
        },
        {
            "name": "SUNLU PLA Marble @BBL A1M",
            "sub_path": "filament/SUNLU/SUNLU Marble PLA @BBL A1M.json"
        },
        {
            "name": "SUNLU PLA Marble @BBL P1P",
            "sub_path": "filament/SUNLU/SUNLU Marble PLA @BBL P1P.json"
        },
        {
            "name": "SUNLU PLA Marble @BBL X1",
            "sub_path": "filament/SUNLU/SUNLU Marble PLA @BBL X1.json"
        },
        {
            "name": "SUNLU PLA Marble @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU Marble PLA @BBL X1C.json"
        },
        {
            "name": "SUNLU PLA Matte @base",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @base.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL A1.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL A1 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL A1M",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL A1M.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL A1M 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL P1P",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL P1P.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL P1P 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL X1",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL X1.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL X1C.json"
        },
        {
            "name": "SUNLU PLA Matte @BBL X1C 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA Matte @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @base",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @base.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL A1.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL A1 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL A1M",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL A1M.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL A1M 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL P1P",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL P1P.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL P1P 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL X1",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL X1.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL X1C.json"
        },
        {
            "name": "SUNLU PLA+ 2.0 @BBL X1C 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ 2.0 @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ @base",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @base.json"
        },
        {
            "name": "SUNLU PLA+ @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL A1.json"
        },
        {
            "name": "SUNLU PLA+ @BBL A1 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ @BBL A1M",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL A1M.json"
        },
        {
            "name": "SUNLU PLA+ @BBL A1M 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ @BBL P1P",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL P1P.json"
        },
        {
            "name": "SUNLU PLA+ @BBL P1P 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "SUNLU PLA+ @BBL X1",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL X1.json"
        },
        {
            "name": "SUNLU PLA+ @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL X1C.json"
        },
        {
            "name": "SUNLU PLA+ @BBL X1C 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU PLA+ @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU Silk PLA+ @base",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @base.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL A1.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL A1 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL A1M",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL A1M.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL A1M 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL P1P",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL P1P.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL P1P 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL X1",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL X1.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL X1C.json"
        },
        {
            "name": "SUNLU Silk PLA+ @BBL X1C 0.2 nozzle",
            "sub_path": "filament/SUNLU/SUNLU Silk PLA+ @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "SUNLU Wood PLA @base",
            "sub_path": "filament/SUNLU/SUNLU Wood PLA @base.json"
        },
        {
            "name": "SUNLU Wood PLA @BBL A1",
            "sub_path": "filament/SUNLU/SUNLU Wood PLA @BBL A1.json"
        },
        {
            "name": "SUNLU Wood PLA @BBL A1M",
            "sub_path": "filament/SUNLU/SUNLU Wood PLA @BBL A1M.json"
        },
        {
            "name": "SUNLU Wood PLA @BBL P1P",
            "sub_path": "filament/SUNLU/SUNLU Wood PLA @BBL P1P.json"
        },
        {
            "name": "SUNLU Wood PLA @BBL X1",
            "sub_path": "filament/SUNLU/SUNLU Wood PLA @BBL X1.json"
        },
        {
            "name": "SUNLU Wood PLA @BBL X1C",
            "sub_path": "filament/SUNLU/SUNLU Wood PLA @BBL X1C.json"
        },
        {
            "name": "eSUN PLA+ @base",
            "sub_path": "filament/eSUN PLA+ @base.json"
        },
        {
            "name": "eSUN PLA+ @BBL A1",
            "sub_path": "filament/eSUN PLA+ @BBL A1.json"
        },
        {
            "name": "eSUN PLA+ @BBL A1 0.2 nozzle",
            "sub_path": "filament/eSUN PLA+ @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "eSUN PLA+ @BBL A1M",
            "sub_path": "filament/eSUN PLA+ @BBL A1M.json"
        },
        {
            "name": "eSUN PLA+ @BBL A1M 0.2 nozzle",
            "sub_path": "filament/eSUN PLA+ @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "eSUN PLA+ @BBL H2D",
            "sub_path": "filament/eSUN PLA+ @BBL H2D.json"
        },
        {
            "name": "eSUN PLA+ @BBL H2D 0.2 nozzle",
            "sub_path": "filament/eSUN PLA+ @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "eSUN PLA+ @BBL P1P",
            "sub_path": "filament/P1P/eSUN PLA+ @BBL P1P.json"
        },
        {
            "name": "eSUN PLA+ @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/eSUN PLA+ @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "eSUN PLA+ @BBL X1",
            "sub_path": "filament/eSUN PLA+ @BBL X1.json"
        },
        {
            "name": "eSUN PLA+ @BBL X1C",
            "sub_path": "filament/eSUN PLA+ @BBL X1C.json"
        },
        {
            "name": "eSUN PLA+ @BBL X1C 0.2 nozzle",
            "sub_path": "filament/eSUN PLA+ @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "fdm_filament_pp",
            "sub_path": "filament/fdm_filament_pp.json"
        },
        {
            "name": "Generic PP @base",
            "sub_path": "filament/Generic PP @base.json"
        },
        {
            "name": "Generic PP @BBL A1",
            "sub_path": "filament/Generic PP @BBL A1.json"
        },
        {
            "name": "Generic PP @BBL A1M",
            "sub_path": "filament/Generic PP @BBL A1M.json"
        },
        {
            "name": "Generic PP @BBL H2D",
            "sub_path": "filament/Generic PP @BBL H2D.json"
        },
        {
            "name": "Generic PP @BBL X1C",
            "sub_path": "filament/Generic PP @BBL X1C.json"
        },
        {
            "name": "Generic PP-CF @base",
            "sub_path": "filament/Generic PP-CF @base.json"
        },
        {
            "name": "Generic PP-CF @BBL A1",
            "sub_path": "filament/Generic PP-CF @BBL A1.json"
        },
        {
            "name": "Generic PP-CF @BBL H2D",
            "sub_path": "filament/Generic PP-CF @BBL H2D.json"
        },
        {
            "name": "Generic PP-CF @BBL X1C",
            "sub_path": "filament/Generic PP-CF @BBL X1C.json"
        },
        {
            "name": "Generic PP-GF @base",
            "sub_path": "filament/Generic PP-GF @base.json"
        },
        {
            "name": "Generic PP-GF @BBL A1",
            "sub_path": "filament/Generic PP-GF @BBL A1.json"
        },
        {
            "name": "Generic PP-GF @BBL H2D",
            "sub_path": "filament/Generic PP-GF @BBL H2D.json"
        },
        {
            "name": "Generic PP-GF @BBL X1C",
            "sub_path": "filament/Generic PP-GF @BBL X1C.json"
        },
        {
            "name": "fdm_filament_ppa",
            "sub_path": "filament/fdm_filament_ppa.json"
        },
        {
            "name": "Bambu PPA-CF @base",
            "sub_path": "filament/Bambu PPA-CF @base.json"
        },
        {
            "name": "Bambu PPA-CF @BBL H2D",
            "sub_path": "filament/Bambu PPA-CF @BBL H2D.json"
        },
        {
            "name": "Bambu PPA-CF @BBL X1C",
            "sub_path": "filament/Bambu PPA-CF @BBL X1C.json"
        },
        {
            "name": "Bambu PPA-CF @BBL X1E",
            "sub_path": "filament/Bambu PPA-CF @BBL X1E.json"
        },
        {
            "name": "Bambu PPA-GF @base",
            "sub_path": "filament/Bambu PPA-GF @base.json"
        },
        {
            "name": "Bambu PPA-GF @BBL H2D",
            "sub_path": "filament/Bambu PPA-GF @BBL H2D.json"
        },
        {
            "name": "Bambu PPA-GF @BBL X1C",
            "sub_path": "filament/Bambu PPA-GF @BBL X1C.json"
        },
        {
            "name": "Bambu PPA-GF @BBL X1E",
            "sub_path": "filament/Bambu PPA-GF @BBL X1E.json"
        },
        {
            "name": "Generic PPA-CF @base",
            "sub_path": "filament/Generic PPA-CF @base.json"
        },
        {
            "name": "Generic PPA-CF @BBL H2D",
            "sub_path": "filament/Generic PPA-CF @BBL H2D.json"
        },
        {
            "name": "Generic PPA-CF @BBL X1C",
            "sub_path": "filament/Generic PPA-CF @BBL X1C.json"
        },
        {
            "name": "Generic PPA-CF @BBL X1E",
            "sub_path": "filament/Generic PPA-CF @BBL X1E.json"
        },
        {
            "name": "Generic PPA-GF @base",
            "sub_path": "filament/Generic PPA-GF @base.json"
        },
        {
            "name": "Generic PPA-GF @BBL H2D",
            "sub_path": "filament/Generic PPA-GF @BBL H2D.json"
        },
        {
            "name": "Generic PPA-GF @BBL X1C",
            "sub_path": "filament/Generic PPA-GF @BBL X1C.json"
        },
        {
            "name": "Generic PPA-GF @BBL X1E",
            "sub_path": "filament/Generic PPA-GF @BBL X1E.json"
        },
        {
            "name": "fdm_filament_pps",
            "sub_path": "filament/fdm_filament_pps.json"
        },
        {
            "name": "Bambu PPS-CF @base",
            "sub_path": "filament/Bambu PPS-CF @base.json"
        },
        {
            "name": "Bambu PPS-CF @BBL H2D",
            "sub_path": "filament/Bambu PPS-CF @BBL H2D.json"
        },
        {
            "name": "Bambu PPS-CF @BBL X1E",
            "sub_path": "filament/Bambu PPS-CF @BBL X1E.json"
        },
        {
            "name": "Generic PPS @base",
            "sub_path": "filament/Generic PPS @base.json"
        },
        {
            "name": "Generic PPS @BBL H2D",
            "sub_path": "filament/Generic PPS @BBL H2D.json"
        },
        {
            "name": "Generic PPS @BBL X1E",
            "sub_path": "filament/Generic PPS @BBL X1E.json"
        },
        {
            "name": "Generic PPS-CF @base",
            "sub_path": "filament/Generic PPS-CF @base.json"
        },
        {
            "name": "Generic PPS-CF @BBL H2D",
            "sub_path": "filament/Generic PPS-CF @BBL H2D.json"
        },
        {
            "name": "Generic PPS-CF @BBL X1E",
            "sub_path": "filament/Generic PPS-CF @BBL X1E.json"
        },
        {
            "name": "fdm_filament_pva",
            "sub_path": "filament/fdm_filament_pva.json"
        },
        {
            "name": "Bambu PVA @base",
            "sub_path": "filament/Bambu PVA @base.json"
        },
        {
            "name": "Bambu PVA @BBL A1",
            "sub_path": "filament/Bambu PVA @BBL A1.json"
        },
        {
            "name": "Bambu PVA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Bambu PVA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu PVA @BBL A1M",
            "sub_path": "filament/Bambu PVA @BBL A1M.json"
        },
        {
            "name": "Bambu PVA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Bambu PVA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Bambu PVA @BBL H2D",
            "sub_path": "filament/Bambu PVA @BBL H2D.json"
        },
        {
            "name": "Bambu PVA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Bambu PVA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu PVA @BBL P1P",
            "sub_path": "filament/Bambu PVA @BBL P1P.json"
        },
        {
            "name": "Bambu PVA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/Bambu PVA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu PVA @BBL X1C",
            "sub_path": "filament/Bambu PVA @BBL X1C.json"
        },
        {
            "name": "Bambu PVA @BBL X1C 0.2 nozzle",
            "sub_path": "filament/Bambu PVA @BBL X1C 0.2 nozzle.json"
        },
        {
            "name": "Generic PVA @base",
            "sub_path": "filament/Generic PVA @base.json"
        },
        {
            "name": "Generic PVA",
            "sub_path": "filament/Generic PVA.json"
        },
        {
            "name": "Generic PVA @0.2 nozzle",
            "sub_path": "filament/Generic PVA @0.2 nozzle.json"
        },
        {
            "name": "Generic PVA @BBL A1",
            "sub_path": "filament/Generic PVA @BBL A1.json"
        },
        {
            "name": "Generic PVA @BBL A1 0.2 nozzle",
            "sub_path": "filament/Generic PVA @BBL A1 0.2 nozzle.json"
        },
        {
            "name": "Generic PVA @BBL A1M",
            "sub_path": "filament/Generic PVA @BBL A1M.json"
        },
        {
            "name": "Generic PVA @BBL A1M 0.2 nozzle",
            "sub_path": "filament/Generic PVA @BBL A1M 0.2 nozzle.json"
        },
        {
            "name": "Generic PVA @BBL H2D",
            "sub_path": "filament/Generic PVA @BBL H2D.json"
        },
        {
            "name": "Generic PVA @BBL H2D 0.2 nozzle",
            "sub_path": "filament/Generic PVA @BBL H2D 0.2 nozzle.json"
        },
        {
            "name": "Generic PVA @BBL P1P",
            "sub_path": "filament/P1P/Generic PVA @BBL P1P.json"
        },
        {
            "name": "Generic PVA @BBL P1P 0.2 nozzle",
            "sub_path": "filament/P1P/Generic PVA @BBL P1P 0.2 nozzle.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "Bambu TPU 85A @base",
            "sub_path": "filament/Bambu TPU 85A @base.json"
        },
        {
            "name": "Bambu TPU 85A @BBL H2D",
            "sub_path": "filament/Bambu TPU 85A @BBL H2D.json"
        },
        {
            "name": "Bambu TPU 85A @BBL P1P",
            "sub_path": "filament/Bambu TPU 85A @BBL P1P.json"
        },
        {
            "name": "Bambu TPU 85A @BBL X1C",
            "sub_path": "filament/Bambu TPU 85A @BBL X1C.json"
        },
        {
            "name": "Bambu TPU 90A @base",
            "sub_path": "filament/Bambu TPU 90A @base.json"
        },
        {
            "name": "Bambu TPU 90A @BBL A1",
            "sub_path": "filament/Bambu TPU 90A @BBL A1.json"
        },
        {
            "name": "Bambu TPU 90A @BBL A1M",
            "sub_path": "filament/Bambu TPU 90A @BBL A1M.json"
        },
        {
            "name": "Bambu TPU 90A @BBL H2D",
            "sub_path": "filament/Bambu TPU 90A @BBL H2D.json"
        },
        {
            "name": "Bambu TPU 90A @BBL P1P",
            "sub_path": "filament/Bambu TPU 90A @BBL P1P.json"
        },
        {
            "name": "Bambu TPU 90A @BBL X1C",
            "sub_path": "filament/Bambu TPU 90A @BBL X1C.json"
        },
        {
            "name": "Bambu TPU 95A @base",
            "sub_path": "filament/Bambu TPU 95A @base.json"
        },
        {
            "name": "Bambu TPU 95A @BBL A1",
            "sub_path": "filament/Bambu TPU 95A @BBL A1.json"
        },
        {
            "name": "Bambu TPU 95A @BBL A1M",
            "sub_path": "filament/Bambu TPU 95A @BBL A1M.json"
        },
        {
            "name": "Bambu TPU 95A @BBL H2D",
            "sub_path": "filament/Bambu TPU 95A @BBL H2D.json"
        },
        {
            "name": "Bambu TPU 95A @BBL P1P",
            "sub_path": "filament/P1P/Bambu TPU 95A @BBL P1P.json"
        },
        {
            "name": "Bambu TPU 95A @BBL X1",
            "sub_path": "filament/Bambu TPU 95A @BBL X1.json"
        },
        {
            "name": "Bambu TPU 95A @BBL X1C",
            "sub_path": "filament/Bambu TPU 95A @BBL X1C.json"
        },
        {
            "name": "Bambu TPU 95A HF @base",
            "sub_path": "filament/Bambu TPU 95A HF @base.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL A1",
            "sub_path": "filament/Bambu TPU 95A HF @BBL A1.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL A1M",
            "sub_path": "filament/Bambu TPU 95A HF @BBL A1M.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL H2D",
            "sub_path": "filament/Bambu TPU 95A HF @BBL H2D.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL P1P",
            "sub_path": "filament/Bambu TPU 95A HF @BBL P1P.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL P1S",
            "sub_path": "filament/Bambu TPU 95A HF @BBL P1S.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL X1",
            "sub_path": "filament/Bambu TPU 95A HF @BBL X1.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL X1C",
            "sub_path": "filament/Bambu TPU 95A HF @BBL X1C.json"
        },
        {
            "name": "Bambu TPU 95A HF @BBL X1E",
            "sub_path": "filament/Bambu TPU 95A HF @BBL X1E.json"
        },
        {
            "name": "Bambu TPU for AMS @base",
            "sub_path": "filament/Bambu TPU for AMS @base.json"
        },
        {
            "name": "Bambu TPU for AMS @BBL A1",
            "sub_path": "filament/Bambu TPU for AMS @BBL A1.json"
        },
        {
            "name": "Bambu TPU for AMS @BBL A1M",
            "sub_path": "filament/Bambu TPU for AMS @BBL A1M.json"
        },
        {
            "name": "Bambu TPU for AMS @BBL H2D",
            "sub_path": "filament/Bambu TPU for AMS @BBL H2D.json"
        },
        {
            "name": "Bambu TPU for AMS @BBL P1P",
            "sub_path": "filament/Bambu TPU for AMS @BBL P1P.json"
        },
        {
            "name": "Bambu TPU for AMS @BBL X1C",
            "sub_path": "filament/Bambu TPU for AMS @BBL X1C.json"
        },
        {
            "name": "Generic TPU @base",
            "sub_path": "filament/Generic TPU @base.json"
        },
        {
            "name": "Generic TPU",
            "sub_path": "filament/Generic TPU.json"
        },
        {
            "name": "Generic TPU @BBL A1",
            "sub_path": "filament/Generic TPU @BBL A1.json"
        },
        {
            "name": "Generic TPU @BBL A1M",
            "sub_path": "filament/Generic TPU @BBL A1M.json"
        },
        {
            "name": "Generic TPU @BBL H2D",
            "sub_path": "filament/Generic TPU @BBL H2D.json"
        },
        {
            "name": "Generic TPU @BBL P1P",
            "sub_path": "filament/P1P/Generic TPU @BBL P1P.json"
        },
        {
            "name": "Generic TPU for AMS @base",
            "sub_path": "filament/Generic TPU for AMS @base.json"
        },
        {
            "name": "Generic TPU for AMS @BBL A1",
            "sub_path": "filament/Generic TPU for AMS @BBL A1.json"
        },
        {
            "name": "Generic TPU for AMS @BBL A1M",
            "sub_path": "filament/Generic TPU for AMS @BBL A1M.json"
        },
        {
            "name": "Generic TPU for AMS @BBL H2D",
            "sub_path": "filament/Generic TPU for AMS @BBL H2D.json"
        },
        {
            "name": "Generic TPU for AMS @BBL P1P",
            "sub_path": "filament/Generic TPU for AMS @BBL P1P.json"
        },
        {
            "name": "Generic TPU for AMS @BBL X1C",
            "sub_path": "filament/Generic TPU for AMS @BBL X1C.json"
        },
        {
            "name": "fdm_filament_dual_common",
            "sub_path": "filament/fdm_filament_dual_common.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "fdm_bbl_3dp_001_common",
            "sub_path": "machine/fdm_bbl_3dp_001_common.json"
        },
        {
            "name": "fdm_bbl_3dp_002_common",
            "sub_path": "machine/fdm_bbl_3dp_002_common.json"
        },
        {
            "name": "Bambu Lab X1 Carbon 0.4 nozzle",
            "sub_path": "machine/Bambu Lab X1 Carbon 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 0.4 nozzle",
            "sub_path": "machine/Bambu Lab X1 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab P1P 0.4 nozzle",
            "sub_path": "machine/Bambu Lab P1P 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab P1S 0.4 nozzle",
            "sub_path": "machine/Bambu Lab P1S 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 mini 0.4 nozzle",
            "sub_path": "machine/Bambu Lab A1 mini 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab X1E 0.4 nozzle",
            "sub_path": "machine/Bambu Lab X1E 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 0.4 nozzle",
            "sub_path": "machine/Bambu Lab A1 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab H2D 0.4 nozzle",
            "sub_path": "machine/Bambu Lab H2D 0.4 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 Carbon 0.2 nozzle",
            "sub_path": "machine/Bambu Lab X1 Carbon 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 Carbon 0.6 nozzle",
            "sub_path": "machine/Bambu Lab X1 Carbon 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 Carbon 0.8 nozzle",
            "sub_path": "machine/Bambu Lab X1 Carbon 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 0.2 nozzle",
            "sub_path": "machine/Bambu Lab X1 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 0.8 nozzle",
            "sub_path": "machine/Bambu Lab X1 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab X1 0.6 nozzle",
            "sub_path": "machine/Bambu Lab X1 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab P1P 0.2 nozzle",
            "sub_path": "machine/Bambu Lab P1P 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab P1P 0.6 nozzle",
            "sub_path": "machine/Bambu Lab P1P 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab P1P 0.8 nozzle",
            "sub_path": "machine/Bambu Lab P1P 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab P1S 0.2 nozzle",
            "sub_path": "machine/Bambu Lab P1S 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab P1S 0.6 nozzle",
            "sub_path": "machine/Bambu Lab P1S 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab P1S 0.8 nozzle",
            "sub_path": "machine/Bambu Lab P1S 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 mini 0.2 nozzle",
            "sub_path": "machine/Bambu Lab A1 mini 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 mini 0.6 nozzle",
            "sub_path": "machine/Bambu Lab A1 mini 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 mini 0.8 nozzle",
            "sub_path": "machine/Bambu Lab A1 mini 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab X1E 0.2 nozzle",
            "sub_path": "machine/Bambu Lab X1E 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab X1E 0.6 nozzle",
            "sub_path": "machine/Bambu Lab X1E 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab X1E 0.8 nozzle",
            "sub_path": "machine/Bambu Lab X1E 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 0.2 nozzle",
            "sub_path": "machine/Bambu Lab A1 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 0.6 nozzle",
            "sub_path": "machine/Bambu Lab A1 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab A1 0.8 nozzle",
            "sub_path": "machine/Bambu Lab A1 0.8 nozzle.json"
        },
        {
            "name": "Bambu Lab H2D 0.2 nozzle",
            "sub_path": "machine/Bambu Lab H2D 0.2 nozzle.json"
        },
        {
            "name": "Bambu Lab H2D 0.6 nozzle",
            "sub_path": "machine/Bambu Lab H2D 0.6 nozzle.json"
        },
        {
            "name": "Bambu Lab H2D 0.8 nozzle",
            "sub_path": "machine/Bambu Lab H2D 0.8 nozzle.json"
        }
    ]
}